'use strict';

var Publicodes = require('publicodes');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Publicodes__default = /*#__PURE__*/_interopDefaultLegacy(Publicodes);

var data = { aides:{ "unité":"€",
    somme:[ { nom:"commune",
        valeur:"0 €" },
      { nom:"intercommunalité",
        valeur:"0 €" },
      { nom:"département",
        valeur:"0 €" },
      { nom:"région",
        valeur:"0 €" },
      { nom:"état",
        valeur:"0 €" } ] },
  "aides . bonus vélo cargo":{ remplace:"état",
    titre:"Bonus vélo cargo de l’État",
    description:"L’État accorde une aide de 1 000 € pour l’achat d’un vélo cargo qu’il soit\nélectrique ou non. Votre revenu fiscal de référence par part doit être\ninférieur à 13 489 € pour en bénéficier.\n",
    "applicable si":{ "toutes ces conditions":[ "localisation . pays = 'France'",
        "revenu fiscal de référence <= 13489 €/an",
        "vélo . cargo" ] },
    valeur:"40% * vélo . prix",
    plafond:"1000€",
    lien:"https://www.service-public.fr/particuliers/vosdroits/F35475" },
  "aides . bonus vélo électrique":{ remplace:"état",
    titre:"Bonus vélo électrique de l’État",
    description:"Le Bonus vélo versé par l’État complète l’aide versée par une collectivité\nterritoriale. Votre revenu fiscal de référence par part doit être inférieur\nà 13 489 € pour en bénéficier. Le montant de l’aide est identique au montant\naccordé par la collectivité dans la limite de 200€.\n",
    "applicable si":{ "toutes ces conditions":[ "localisation . pays = 'France'",
        "revenu fiscal de référence <= 13489 €/an",
        "vélo . électrique" ] },
    somme:[ "commune",
      "intercommunalité",
      "département",
      "région" ],
    plafond:"200 €",
    lien:"https://www.service-public.fr/particuliers/vosdroits/F35475" },
  "aides . prime à la conversion":{ "applicable si":{ "toutes ces conditions":[ "localisation . pays = 'France'",
        "vélo . type = ''" ] },
    titre:"Prime à la conversion",
    description:"Pour bénéficier de cette « prime à la casse » vous devez détruire un\nvéhicule diesel immatriculé avant janvier 2011 ou bien un véhicule essence\nimmatriculé avant 2006.\n\nLa prime est de 40% du prix du vélo dans la limite de 1 500 €. Elle est\ncumulable avec les aides à l'achat d’un vélo électrique, comme le « bonus\nécologique ».\n",
    valeur:"40% * vélo . prix",
    plafond:"1500€",
    lien:"https://www.service-public.fr/particuliers/vosdroits/F35846" },
  "aides . ile de france":{ remplace:"région",
    titre:"Île-de-France Mobilités",
    description:"La région Île-De-France subventionne l’achat d’un $vélo à hauteur de 50% et\njusqu’à un plafond de $plafond. Les éventuelles aides locales déjà perçues\nsont déduites de ce montant.\n",
    "applicable si":{ "toutes ces conditions":[ "localisation . région = '11'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo",
            "vélo . pliant" ] } ] },
    valeur:"50% * vélo . prix",
    plafond:{ valeur:{ nom:"$plafond",
        variations:[ { si:"vélo . cargo électrique",
            alors:"600 €" },
          { sinon:"500 €" } ] },
      abattement:"aides . commune" },
    lien:"https://www.iledefrance-mobilites.fr/le-reseau/services-de-mobilite/velo/prime-achat-velo" },
  "aides . occitanie":{ remplace:"région",
    titre:"Région Occitanie",
    "applicable si":{ "toutes ces conditions":[ "localisation . région = '76'",
        "vélo . électrique",
        "revenu fiscal de référence <= 25660 €/an" ] },
    valeur:"200 €",
    lien:"https://lio.laregion.fr/aides-achat-velo" },
  "aides . corse":{ remplace:"région",
    titre:"Région Corse",
    "applicable si":{ "toutes ces conditions":[ "localisation . région = '94'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"500€",
    lien:"https://www.aue.corsica/Aide-a-l-achat-des-Velos-a-Assistance-Electrique_a205.html" },
  "aides . grand est":{ remplace:"région",
    titre:"Région Grand Est",
    "applicable si":{ "toutes ces conditions":[ "localisation . région = '44'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . motorisation" ] } ] },
    valeur:"200€",
    lien:"https://www.grandest.fr/vos-aides-regionales/acquisition-velo-electrique/" },
  "aides . bouches du rhone":{ remplace:"département",
    titre:"Département des Bouches-du-Rhône",
    "applicable si":{ "toutes ces conditions":[ "localisation . département = '13'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"400€",
    lien:"https://www.departement13.fr/400-euros-pour-achat-velo-assistance-electrique/" },
  "aides . paris":{ remplace:"commune",
    titre:"Ville de Paris",
    description:"La ville de Paris subventionne l’achat d’un $vélo à hauteur de 33% et\njusqu’à un plafond de $plafond.\n",
    "applicable si":"localisation . code insee = '75056'",
    valeur:"33% * vélo . prix . HT",
    plafond:{ nom:"$plafond",
      variations:[ { si:"vélo . cargo",
          alors:"600€" },
        { si:"vélo . électrique",
          alors:"400€" },
        { si:"vélo . motorisation",
          alors:"400€" },
        { sinon:"0€" } ] },
    lien:"https://www.paris.fr/pages/lutte-contre-la-pollution-les-aides-a-la-mobilite-5373" },
  "aides . lyon":{ remplace:"intercommunalité",
    titre:"Métropole Grand Lyon",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Métropole de Lyon'",
        { "une de ces conditions":[ "vélo . cargo",
            { "toutes ces conditions":[ "vélo . prix <= 3000 €",
                { "une de ces conditions":[ "vélo . électrique",
                    "vélo . pliant" ] } ] } ] } ] },
    valeur:"50% * vélo . prix",
    plafond:{ variations:[ { si:"revenu fiscal de référence <= 13489 €/an",
          alors:"500€" },
        { sinon:"100€" } ] },
    lien:"https://www.grandlyon.com/services/aide-achat-velo.html" },
  "aides . villefranche beaujolais saône":{ remplace:"intercommunalité",
    titre:"VilleFranche Beaujolais Saône Agglo",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Villefranche Beaujolais Saône'",
        "vélo . électrique ou mécanique" ] },
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"200€" },
        { sinon:"100€" } ] },
    lien:"https://www.agglo-villefranche.fr/aide-a-lachat-velo.html" },
  "aides . sainte foy lès lyon":{ remplace:"commune",
    titre:"Ville de Sainte Foy-Lès-Lyon",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '69202'",
        { "une de ces conditions":[ "vélo . électrique ou mécanique",
            "vélo . motorisation" ] } ] },
    valeur:"100€",
    lien:"https://www.saintefoyleslyon.fr/Territoire-d-avenir/Deplacements/100-euros-pour-l-achat-d-un-velo" },
  "aides . mornant":{ remplace:"commune",
    titre:"Ville de Mornant",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '69141'",
        "vélo . électrique" ] },
    variations:[ { si:"revenu fiscal de référence <= 1000 €/mois",
        alors:"250€" },
      { sinon:"150€" } ],
    lien:"https://www.ville-mornant.fr/Aide-acquisition-velo-a-assistance-electrique-mornant-art-283.html" },
  "aides . dardilly":{ remplace:"commune",
    titre:"Ville de Dardilly",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '69072'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"250€",
    lien:"https://www.dardilly.fr/mes-infos-quotidiennes/actus-evenements/31-vie-citoyenne/91-subventions-eco-citoyennes" },
  "aides . saint-etienne":{ remplace:"intercommunalité",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Saint-Etienne Métropole'",
        "vélo . électrique" ] },
    description:"La Métropole allouera 100 000 € à cette opération en 2022, qui sera\nrenouvelée chaque année jusqu'en 2026\n",
    titre:"Saint-Étienne Métropole",
    variations:[ { si:"ménage imposable = 'non'",
        alors:"200€" },
      { sinon:"100€" } ],
    lien:"https://www.saint-etienne.fr/actualites/v%C3%A9lo-passez-%C3%A0-l%C3%A9lectrique" },
  "aides . bordeaux":{ remplace:"intercommunalité",
    titre:"Bordeaux Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Bordeaux Métropole'",
        "revenu fiscal de référence <= 2200 €/mois",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo",
            "vélo . pliant",
            "vélo . motorisation" ] } ] },
    valeur:"100 €",
    lien:"https://sedeplacer.bordeaux-metropole.fr/Velo/Pratique/Aide-a-l-achat-de-velo" },
  "aides . département saône-et-loire":{ remplace:"département",
    titre:"Département de Saône-et-Loire",
    "applicable si":"localisation . département = '71'",
    variations:[ { si:"vélo . cargo électrique",
        alors:"450€" },
      { si:{ "toutes ces conditions":[ "vélo . électrique",
            "vélo . prix >= 1000 €" ] },
        alors:"350€" },
      { si:{ "toutes ces conditions":[ "vélo . mécanique",
            "vélo . prix >= 500 €" ] },
        alors:"200€" },
      { si:"vélo . motorisation",
        alors:{ valeur:"80% * vélo . prix",
          plafond:"100€" } },
      { sinon:"0€" } ],
    lien:"https://www.saoneetloire71.fr/chequevelo" },
  "aides . mérignac":{ remplace:"commune",
    titre:"Ville de Mérignac",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '33281'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . pliant",
            "vélo . cargo" ] } ] },
    valeur:"100€",
    lien:"https://www.merignac.com/actualites/une-aide-de-100-eu-pour-un-velo-electrique-pliant-ou-cargo" },
  "aides . saint-émilionnais":{ remplace:"intercommunalité",
    titre:"Communauté de communes du Grand Saint-Émilionnais",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC du Grand Saint Emilionnais'",
        "vélo . électrique ou mécanique",
        "vélo . prix >= 200€" ] },
    valeur:"200€",
    lien:"http://www.grand-saint-emilionnais.fr/actualites/un-projet-velo-la-cdc-vous-aide-primovelo/" },
  "aides . pays de la loire":{ remplace:"région",
    titre:"Région Pays de la Loire",
    "applicable si":{ "toutes ces conditions":[ "localisation . région = '52'",
        "vélo . pliant",
        { nom:"abonné TER",
          question:"Êtes-vous abonnés du TER Pays de la Loire ?",
          description:"Sont éligibles les abonnés Tutti illimité, Métrocéane mensuels, les\naboonés annuels de Loire-Atlantique, Maine et Loire et Sarthe, ainsi\nque les abonnés mensuels des réseaux de Mayenne et Vendée (hors\nscolaires).\n",
          type:"booléen",
          "par défaut":"oui" } ] },
    description:"Cette aide à l’achat d’un vélo pliant est reservée aux abonnés du TER Pays\nde la Loire.\n",
    valeur:"50% * vélo . prix",
    plafond:"200€",
    lien:"https://www.paysdelaloire.fr/les-aides/aide-lachat-dun-velo-pliant-ou-assistance-electrique-vae-pour-les-abonnes-aleop" },
  "aides . nantes":{ remplace:"intercommunalité",
    titre:"Nantes Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Nantes Métropole'",
        "vélo . cargo" ] },
    valeur:"25% * vélo . prix",
    plafond:"300 €",
    lien:"https://metropole.nantes.fr/aide-achat-velo-cargo" },
  "aides . toulouse":{ remplace:"intercommunalité",
    titre:"Toulouse Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Toulouse Métropole'",
        "revenu fiscal de référence <= 35052 €/an" ] },
    valeur:"40% * vélo . prix . HT",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:{ variations:[ { si:"revenu fiscal de référence <= 18800 €/an",
                alors:"600€" },
              { sinon:"500€" } ] } },
        { si:"vélo . cargo",
          alors:{ variations:[ { si:"revenu fiscal de référence <= 18800 €/an",
                alors:"400€" },
              { sinon:"350€" } ] } },
        { si:"vélo . électrique",
          alors:{ variations:[ { si:"revenu fiscal de référence <= 18800 €/an",
                alors:"250€" },
              { sinon:"200€" } ] } },
        { si:"vélo . mécanique",
          alors:{ variations:[ { si:"revenu fiscal de référence <= 18800 €/an",
                alors:"100€" },
              { sinon:"0€" } ] } },
        { sinon:"0€" } ] },
    lien:"https://www.toulouse-metropole.fr/missions/environnement/qualite-de-l-air/prime-velo" },
  "aides . nice":{ remplace:"intercommunalité",
    titre:"Métropole Nice Côte d’Azur",
    "applicable si":"localisation . epci = 'Métropole Nice Côte d’Azur'",
    valeur:{ variations:[ { si:"vélo . électrique",
          alors:{ valeur:"25% * vélo . prix",
            plafond:"400€" } },
        { si:"vélo . mécanique",
          alors:{ valeur:"50% * vélo . prix",
            plafond:"100€" } } ] },
    lien:"https://www.nicecotedazur.org/deplacement/subvention-pour-l-achat-d-un-v%C3%A9lo-%C3%A0-propulsion-humaine" },
  "aides . strasbourg":{ remplace:"intercommunalité",
    titre:"Eurométropole de Strasbourg",
    "applicable si":"localisation . epci = 'Eurométropole de Strasbourg'",
    valeur:"50% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:"500€" },
        { si:"vélo . électrique",
          alors:{ grille:{ assiette:"revenu fiscal de référence",
              tranches:[ { plafond:"6300 €/an",
                  montant:"500 €" },
                { plafond:"13489 €/an",
                  montant:"400 €" },
                { montant:"300 €" } ] } } },
        { si:"vélo . motorisation",
          alors:"150€" },
        { sinon:"0€" } ] },
    lien:"https://www.strasbourg.eu/aides-achat" },
  "aides . entzheim":{ remplace:"commune",
    titre:"Ville de Entzheim",
    "applicable si":"localisation . code insee = '67124'",
    variations:[ { si:"vélo . cargo",
        alors:{ valeur:"10% * vélo . prix",
          plafond:"200€" } },
      { si:"vélo . électrique",
        alors:{ valeur:"10% * vélo . prix",
          plafond:"150€" } },
      { si:"vélo . mécanique simple",
        alors:{ valeur:"30% * vélo . prix",
          plafond:"80€" } },
      { sinon:"0€" } ],
    lien:"http://www.entzheim.fr/fr/information/113321/aide-achat-un-velo-neuf-ou-reparation-un-velo" },
  "aides . geispolsheim":{ remplace:"commune",
    titre:"Ville de Geispolsheim",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '67152'",
        "vélo . électrique" ] },
    variations:[ { si:"ménage imposable = 'non'",
        alors:"200€" },
      { si:"revenu fiscal de référence <= 750 €/mois",
        alors:"150€" },
      { sinon:"100€" } ],
    lien:"https://www.geispolsheim.fr/fr/subventions-transport-et-velo-a-assistance-electrique" },
  "aides . hangenbieten":{ remplace:"commune",
    titre:"Ville de Hangenbieten",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '67182'",
        "vélo . électrique" ] },
    variations:[ { si:"revenu fiscal de référence <= 560 €/mois",
        alors:"120€" },
      { si:"revenu fiscal de référence <= 764 €/mois",
        alors:"100€" },
      { sinon:"80€" } ],
    lien:"https://hangenbieten.fr/wp-content/uploads/2021/03/SKM_C30821031516140.pdf#page=4" },
  "aides . illkirch":{ remplace:"commune",
    titre:"Ville de Illkirch-Graffenstaden",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '67218'",
        "vélo . électrique" ] },
    variations:[ { si:"vélo . prix <= 600€",
        alors:"50€" },
      { si:"vélo . prix <= 800€",
        alors:"100€" },
      { sinon:"200€" } ],
    lien:"http://www.illkirch.eu/aide-a-lachat-dun-velo-a-assistance-electrique/" },
  "aides . plobsheim":{ remplace:"commune",
    titre:"Ville de Plobsheim",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '67378'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"100€",
    lien:"https://www.plobsheim.fr/subvention-pour-lachat-dun-velo/" },
  "aides . vendenheim":{ remplace:"commune",
    titre:"Ville de Vendenheim",
    "applicable si":"localisation . code insee = '67506'",
    variations:[ { si:"vélo . électrique",
        alors:"250€" },
      { si:"vélo . mécanique",
        alors:"80€" },
      { sinon:"0€" } ],
    lien:"https://vendenheim.fr/aides-et-subventions/" },
  "aides . albi":{ remplace:"intercommunalité",
    titre:"Grand Albigeois",
    "applicable si":"localisation . epci = 'CA de l’Albigeois (C2A)'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"500 €" },
        { si:"vélo . électrique",
          alors:"250 €" },
        { si:"vélo . mécanique",
          alors:"100 €" },
        { sinon:"0 €" } ] },
    lien:"https://www.grand-albigeois.fr/1591-aide-a-l-achat-de-velo.htm" },
  "aides . toulon":{ remplace:"intercommunalité",
    titre:"Métropole Toulon-Provence-Méditerranée",
    "applicable si":"localisation . epci = 'Métropole Toulon-Provence-Méditerranée'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"250 €" },
        { si:"vélo . motorisation",
          alors:"150 €" },
        { sinon:"0 €" } ] },
    lien:"https://metropoletpm.fr/tourisme/proxy/tpm-s-engage-velo-electrique" },
  "aides . bretagne romantique":{ remplace:"intercommunalité",
    titre:"Communauté de communes Bretagne romantique",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC Bretagne Romantique'",
        "vélo . électrique" ] },
    valeur:"100€",
    plafond:"vélo . prix",
    lien:"https://bretagneromantique.fr/prime-velo/" },
  "aides . quimper":{ remplace:"intercommunalité",
    titre:"Quimper Bretagne Occidentale",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Quimper Bretagne Occidentale'",
        "vélo . électrique" ] },
    variations:[ { si:"revenu fiscal de référence <= 13489 €/an",
        alors:{ valeur:"50% * vélo . prix",
          plafond:"500€" } },
      { si:"revenu fiscal de référence <= 20000 €/an",
        alors:{ valeur:"40% * vélo . prix",
          plafond:"400€" } },
      { si:"revenu fiscal de référence <= 26350 €/an",
        alors:{ valeur:"20% * vélo . prix",
          plafond:"200€" } },
      { sinon:"0€" } ],
    lien:"https://www.quimper-bretagne-occidentale.bzh/1763-deplacements-a-velo.htm" },
  "aides . quimperlé":{ remplace:"intercommunalité",
    titre:"Quimperlé Communauté",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Quimperlé Communauté'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"150€",
    lien:"https://www.quimperle-communaute.bzh/vos-demarches/deplacements/aide-a-lachat-de-velo-electrique/" },
  "aides . laon":{ remplace:"intercommunalité",
    titre:"Pays de Laon",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Pays de Laon'",
        "vélo . électrique" ] },
    valeur:"300€",
    plafond:"vélo . prix",
    lien:"http://www.ca-paysdelaon.fr/Aide_VAE/index.html" },
  "aides . caen":{ remplace:"commune",
    titre:"Ville de Caen",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14118'",
        "vélo . électrique",
        "revenu fiscal de référence <= 13489 €/an" ] },
    valeur:{ variations:[ { si:"vélo . cargo électrique",
          alors:"400€" },
        { sinon:"300€" } ] },
    plafond:"vélo . prix",
    lien:"https://caen.fr/velo-pied" },
  "aides . caen la mer":{ remplace:"intercommunalité",
    titre:"Caen la mer communauté urbaine",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CU Caen la Mer'",
        "aides . commune > 0",
        "vélo . électrique" ] },
    valeur:"50€",
    lien:"https://caenlamer.fr/actualites/aide-de-caen-la-mer-pour-lachat-de-velo-assistance-electrique" },
  "aides . carpiquet":{ remplace:"commune",
    titre:"Ville de Carpiquet",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14137'",
        "vélo . électrique" ] },
    valeur:"150€",
    lien:"http://www.carpiquet-mairie.fr/wa_files/CONVENTION_20RELATIVE_20A_20L_27ACQUISITION_20D_27UN_20VAE_20OU_20D_27UNE_20TROTTINETTE_20A_20ASSIST.pdf" },
  "aides . herouville":{ remplace:"commune",
    titre:"Ville d’Hérouville Saint-Clair",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14327'",
        "vélo . électrique",
        "vélo . prix <= 2500€" ] },
    valeur:"100€",
    lien:"https://www.herouville.net/services/cadre-de-vie-environnement/vos-deplacements-doux" },
  "aides . ifs":{ remplace:"commune",
    titre:"Ville d’ifs",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14341'",
        "vélo . électrique",
        "revenu fiscal de référence <= 24000€/an",
        "vélo . prix <= 2500€" ] },
    valeur:"10% * vélo . prix",
    plafond:"100€",
    lien:"https://ville-ifs.fr/storage/app/uploads/public/5b3/0b5/eed/5b30b5eed183e270384162.pdf" },
  "aides . mondeville":{ remplace:"commune",
    titre:"Ville de Mondeville",
    "applicable si":"localisation . code insee = '14437'",
    variations:[ { si:"vélo . électrique",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"620 €/mois",
                montant:"300€" },
              { plafond:"920 €/mois",
                montant:"200€" },
              { plafond:"1200 €/mois",
                montant:"100€" } ] } } },
      { si:"vélo . cargo",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"620 €/mois",
                montant:"400€" },
              { plafond:"920 €/mois",
                montant:"300€" },
              { plafond:"1200 €/mois",
                montant:"200€" } ] } } },
      { si:"vélo . mécanique",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"620 €/mois",
                montant:"50€" } ] } } } ],
    lien:"http://www.mondeville.fr/vivre_a_mondeville/prime_a_l_achat_d_un_velo.html" },
  "aides . ronchin":{ remplace:"commune",
    titre:"Ville de Ronchin",
    "applicable si":"localisation . code insee = '59507'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"300€" },
        { si:"vélo . mécanique",
          alors:"150€" },
        { sinon:"0€" } ] },
    lien:"https://www.ville-ronchin.fr/aide-lachat-dun-velo" },
  "aides . porte du hainaut":{ remplace:"intercommunalité",
    titre:"La Porte du Hainaut communauté d'Agglomération",
    "applicable si":"localisation . epci = 'CA de la Porte du Hainaut'",
    description:"Dans la limite de l’enveloppe budgétaire de 100 000 €.",
    variations:[ { si:"vélo . électrique",
        alors:"300€" },
      { si:"vélo . mécanique",
        alors:"150€" },
      { sinon:"0€" } ],
    plafond:"50% * vélo . prix",
    lien:"https://www.agglo-porteduhainaut.fr/actualites/une-aide-pour-acheter-velo-et-trottinettes" },
  "aides . wasquehal":{ remplace:"commune",
    titre:"Ville de Wasquehal",
    "applicable si":"localisation . code insee = '59646'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"250€" },
        { si:"vélo . mécanique",
          alors:"125€" },
        { sinon:"0€" } ] },
    lien:"https://www.ville-wasquehal.fr/actualite/aides-de-la-ville-pour-une-mobilite-douce/" },
  "aides . ouistreham":{ remplace:"commune",
    titre:"Ouistreham Riva-Bella",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14488'",
        "vélo . électrique" ] },
    variations:[ { si:"revenu fiscal de référence <= 21640 €/an",
        alors:"200€" },
      { sinon:"100€" } ],
    lien:"http://ouistreham-rivabella.fr/wp-content/uploads/2019/05/Dossier-de-subvention-velos.pdf" },
  "aides . verson":{ remplace:"commune",
    titre:"Ville de Verson",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14738'",
        "revenu fiscal de référence <= 13489 €/an" ] },
    variations:[ { si:"vélo . électrique",
        alors:"250€" },
      { si:"vélo . mécanique",
        alors:"50€" },
      { sinon:"0€" } ],
    lien:"http://www.ville-verson.fr/actualites/prime-velo/" },
  "aides . cormelles le royal":{ remplace:"commune",
    titre:"Ville de Cormelles le Royal",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14181'",
        "vélo . électrique" ] },
    valeur:"200€",
    lien:"https://www.ville-de-cormelles-le-royal.fr/mairie/pdf/VAE.pdf" },
  "aides . saint-germain la blanche herbe":{ remplace:"commune",
    titre:"Ville de Saint-Germain la Blanche Herbe",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '14587'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://www.mairie-stgermainblancheherbe.fr/29-actualites/658-aide-pour-l-achat-d-un-velo-electrique" },
  "aides . trouville sur mer":{ remplace:"commune",
    titre:"Ville de Trouville-sur-Mer",
    "applicable si":"localisation . code insee = '14715'",
    valeur:"30% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"400€" },
        { si:"vélo . électrique",
          alors:"300€" },
        { sinon:"0€" } ] },
    lien:"https://www.trouville.fr/wp-content/uploads/2021/04/Demande-Subvention-Ve%CC%81lo-5.pdf" },
  "aides . deauville":{ remplace:"commune",
    titre:"Ville de Deauville",
    "applicable si":"localisation . code insee = '14220'",
    valeur:"30% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"400€" },
        { si:"vélo . électrique",
          alors:"300€" },
        { si:"vélo . pliant",
          alors:"80€" },
        { si:"vélo . mécanique simple",
          alors:"150€" },
        { sinon:"0€" } ] },
    lien:"https://actu.fr/normandie/deauville_14220/deauville-la-ville-maintient-son-aide-pour-l-achat-d-un-velo-neuf_38851211.html" },
  "aides . montlouis sur loire":{ remplace:"commune",
    titre:"Montlouis sur Loire",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '37156'",
        "vélo . électrique" ] },
    valeur:"200€",
    lien:"https://www.ville-montlouis-loire.fr/aide-a-lachat-dun-velo-electrique-neuf/" },
  "aides . martigues":{ remplace:"commune",
    titre:"Ville de Martigues",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '13056'",
        "vélo . électrique" ] },
    valeur:"250€",
    lien:"https://www.ville-martigues.fr/services-en-ligne/deplacements/velo-a-assistance-electrique-aide-a-lachat" },
  "aides . montbéliard agglo":{ remplace:"intercommunalité",
    titre:"Pays de Montbéliard Agglomération",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Pays de Montbéliard Agglomération'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://aidevelo.agglo-montbeliard.fr/" },
  "aides . besançon":{ remplace:"intercommunalité",
    titre:"Grand Besançon Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CU Grand Besançon Métropole'",
        "vélo . électrique",
        "revenu fiscal de référence <= 19665 €/an" ] },
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:"400€" },
        { sinon:"200€" } ] },
    lien:"https://www.grandbesancon.fr/demarche-administrative/subvention-pour-lachat-dun-velo-electrique/" },
  "aides . montbéliard":{ remplace:"commune",
    titre:"Ville de Montbéliard",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '25388'",
        "vélo . électrique" ] },
    valeur:"150€",
    lien:"https://www.montbeliard.fr/pages-datterrissage-temporaires/subvention-pour-lachat-dun-velo-a-assistance-electrique.html" },
  "aides . vienne condrieu":{ remplace:"intercommunalité",
    titre:"Vienne Condrieu Agglomération",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Vienne Condrieu'",
        "vélo . électrique" ] },
    valeur:"150€",
    lien:"https://www.vienne-condrieu-agglomeration.fr/nos-services-au-quotidien/deplacements/faire-du-velo/aide-financiere-vae/" },
  "aides . vif":{ remplace:"commune",
    titre:"Ville de Vif",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '38545'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://ville-vif.fr/velo-a-assistance-electrique-100-e-offerts/" },
  "aides . meyreuil":{ remplace:"commune",
    titre:"Ville de Meyreuil",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '13060'",
        "vélo . électrique" ] },
    valeur:"15% * vélo . prix",
    plafond:"300€",
    lien:"https://www.ville-meyreuil.fr/fr/actualites/id-915--pedalez-branche-prime-pour-l-achat-d-un-velo-electrique" },
  "aides . ploemeur":{ remplace:"commune",
    titre:"Ville de Ploemeur",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '56162'",
        "vélo . électrique" ] },
    valeur:"30% * vélo . prix",
    plafond:"300€",
    lien:"https://www.ploemeur.com/2021/06/08/une-aide-pour-lachat-dun-velo-electrique/" },
  "aides . daix":{ remplace:"commune",
    titre:"Ville de Daix",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '21223'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"400€",
    lien:"https://www.daix.fr/fichiers/news_fichiers1/13/Le%20deux-roues%20electrique_vert.pdf" },
  "aides . chateau du loir":{ remplace:"commune",
    titre:"Ville de Château du Loir",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '33009'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"150€",
    lien:"https://ville-chateauduloir.fr/developpement-durable.html" },
  "aides . sorgues du comtat":{ remplace:"intercommunalité",
    titre:"Communauté de communes des Sorgues du Comtat",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC des Sorgues du Comtat'",
        "vélo . électrique" ] },
    valeur:"20% * vélo . prix",
    plafond:"120€",
    lien:"https://www.sorgues.fr/vivre/demarches/prime-velo.htm" },
  "aides . grand périgueux":{ remplace:"intercommunalité",
    titre:"Grand Périgueux",
    "applicable si":"localisation . epci = 'CA Le Grand Périgueux'",
    variations:[ { si:"vélo . cargo",
        alors:"500€" },
      { si:"vélo . électrique",
        alors:"250€" },
      { si:"vélo . mécanique",
        alors:{ valeur:"30€",
          plafond:"50% * vélo . prix" } } ],
    plafond:"vélo . prix",
    lien:"https://www.grandperigueux.fr/au-quotidien/deplacements/cap-sur-le-velo/aide-a-lachat-velo/cheques-velo" },
  "aides . sarlat":{ remplace:"commune",
    titre:"Ville de Sarlat",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '24520'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://www.sarlat.fr/100-e-daide-pour-lachat-dun-velo-electrique/" },
  "aides . sablé sur sarthe":{ remplace:"commune",
    titre:"Communauté de communes des Sablé sur Sarthe",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '72264'",
        "vélo . électrique" ] },
    valeur:"10% * vélo . prix",
    plafond:"100€",
    lien:"https://www.sablesursarthe.fr/pratique/je-veux/demarches-administratives/aide-a-lachat-dun-velo-electrique/" },
  "aides . département somme":{ remplace:"département",
    titre:"Département de la Somme",
    "applicable si":{ "toutes ces conditions":[ "localisation . département = '80'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"400€",
    lien:"https://www.somme.fr/services/loisirs-et-sports/sports-et-loisirs-de-nature/aide-a-lacquisition-de-velo-a-assistance-electrique/" },
  "aides . amiens":{ remplace:"commune",
    titre:"Ville d’Amiens",
    "applicable si":"localisation . code insee = '80021'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"300€" },
        { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"https://www.amiens.fr/Actualites/L-aide-a-l-achat-de-velo-s-electrise" },
  "aides . camon":{ remplace:"commune",
    titre:"Ville de Camon",
    "applicable si":"localisation . code insee = '80164'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"300€" },
        { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"https://www.camon.fr/aide-a-lachat-de-velos/" },
  "aides . rivery":{ remplace:"commune",
    titre:"Ville de Rivery",
    "applicable si":"localisation . code insee = '80674'",
    valeur:"20% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"100€" },
        { si:"vélo . mécanique",
          alors:"50€" },
        { sinon:"0€" } ] },
    lien:"https://www.ville-rivery.fr/2021/05/04/aide-financiere-a-lachat-dun-velo/" },
  "aides . faches-thumesnil":{ remplace:"commune",
    titre:"Ville de Faches-Thumesnil",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '59220'",
        "vélo . électrique ou mécanique" ] },
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . mécanique",
          alors:"150€" },
        { si:"vélo . électrique",
          alors:"300€" },
        { sinon:"0€" } ] },
    lien:"https://www.ville-fachesthumesnil.fr/Ecologie-cadre-de-vie/Urgences-Ecologiques/Nos-actions/Prime-velo" },
  "aides . pays sainte odile":{ remplace:"commune",
    titre:"Pays de Sainte Odile",
    "applicable si":"localisation . epci = 'CC du Pays de Sainte-Odile'",
    variations:[ { si:"vélo . cargo",
        alors:{ valeur:"10% * vélo . prix",
          plafond:"180€" } },
      { si:"vélo . électrique",
        alors:{ valeur:"10% * vélo . prix",
          plafond:"120€" } },
      { si:"vélo . mécanique",
        alors:{ valeur:"20% * vélo . prix",
          plafond:"60€" } },
      { sinon:"0€" } ],
    lien:"http://www.cc-paysdesainteodile.fr/competences/se-deplacer/2/" },
  "aides . portes de rosheim":{ remplace:"intercommunalité",
    titre:"Communauté de communes des Portes de Rosheim",
    "applicable si":"localisation . epci = 'CC des Portes de Rosheim'",
    description:"La communauté de communes a prévu un budget de 40 000 € en 2022",
    variations:[ { si:"vélo . cargo électrique",
        alors:{ valeur:"10% * vélo . prix",
          plafond:"180€" } },
      { si:"vélo . électrique",
        alors:{ valeur:"10% * vélo . prix",
          plafond:"120€" } },
      { si:"vélo . mécanique",
        alors:{ valeur:"20% * vélo . prix",
          plafond:"60€" } } ],
    lien:"https://www.cc-portesderosheim.fr/services_a_la_population/prime_a_lachat_dun_velo_neuf_80.php" },
  "aides . pays rhénan":{ remplace:"intercommunalité",
    titre:"Communes du Pays Rhénan",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC du Pays Rhénan'",
        "vélo . électrique" ] },
    valeur:"200€",
    lien:"https://www.cc-paysrhenan.fr/Actualites/AIDE-ACHAT-UN-VELO-ASSISTANCE-ELECTRIQUE-00626.html" },
  "aides . les sables d'olonne":{ remplace:"intercommunalité",
    titre:"Les Sables d'Olonne",
    "applicable si":"localisation . epci = 'CA Les Sables d’Olonne Agglomération'",
    valeur:{ variations:[ { si:"vélo . cargo",
          alors:"25% * vélo . prix" },
        { si:"vélo . électrique",
          alors:"25% * vélo . prix" },
        { sinon:"50% * vélo . prix" } ] },
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"300€" },
        { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"http://www.lsoagglo.fr/vivreauxolonnes/vie-pratique/transports/plan-velo-2025/" },
  "aides . vallons du lyonnais":{ remplace:"intercommunalité",
    titre:"Communauté de Communes des Vallons du Lyonnais",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC des Vallons du Lyonnais (CCVL)'",
        "vélo . électrique" ] },
    valeur:"200€",
    lien:"http://www.ccvl.fr/page.php?page=DT1620223333" },
  "aides . département Hérault":{ remplace:"département",
    titre:"Département Hérault",
    "applicable si":{ "toutes ces conditions":[ "localisation . département = '34'",
        "vélo . électrique",
        "revenu fiscal de référence <= 27086 €/an" ] },
    valeur:"vélo . prix",
    plafond:"250€",
    lien:"https://herault.fr/409-mon-velo.htm" },
  "aides . montpellier":{ remplace:"intercommunalité",
    titre:"Montpellier Méditerranée Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Montpellier Méditerranée Métropole'",
        "vélo . électrique" ] },
    valeur:"50% * vélo . prix",
    plafond:"500€",
    lien:"https://www.montpellier3m.fr/actualite/jusqua-1150-eu-daide-pour-lachat-dun-velo-assistance-electrique" },
  "aides . sete":{ remplace:"intercommunalité",
    titre:"Sète Agglopôle méditerranée",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Sète Agglopôle Méditerranée'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"200€",
    lien:"https://www.agglopole.fr/lagglo-subventionne-lachat-de-velos-et-trottinettes-electriques/" },
  "aides . puy de dome":{ remplace:"département",
    titre:"Département Puy-de-Dôme",
    "applicable si":{ "toutes ces conditions":[ "localisation . département = '63'",
        "vélo . électrique" ] },
    valeur:"20% * vélo . prix",
    plafond:"500€",
    lien:"https://www.puy-de-dome.fr/actualites/mai-2021/aide-a-lachat-de-vae.html" },
  "aides . pays d'issoire":{ remplace:"intercommunalité",
    titre:"Agglo Pays D'Issoire",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Agglo Pays d’Issoire'",
        "vélo . électrique" ] },
    valeur:"150€",
    plafond:"vélo . prix",
    lien:"http://www.mairie-egliseneuvedesliards.fr/fileadmin/Mairie_Egliseneuve-des-Liards/2-Documents/pdf/Prime-VAE_Formulaire-demande1309.pdf" },
  "aides . cébazat":{ remplace:"commune",
    titre:"Ville de Cébazat",
    "applicable si":"localisation . code insee = '63063'",
    variations:[ { si:"vélo . électrique",
        alors:"150€" },
      { si:"vélo . motorisation",
        alors:"100€" },
      { si:"vélo . pliant",
        alors:"50€" },
      { sinon:"0€" } ],
    plafond:"vélo . prix",
    lien:"http://www.cebazat.fr/Plan-velo-communal.html" },
  "aides . aubiere":{ remplace:"commune",
    titre:"Ville d’Aubière",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '63014'",
        "vélo . électrique" ] },
    valeur:"150€",
    plafond:"vélo . prix",
    lien:"https://ville-aubiere.fr/2021/02/17/passez-au-velo-pedalez-branche/" },
  "aides . romagnat":{ remplace:"commune",
    titre:"Ville de Romagnat",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '63307'",
        "vélo . électrique" ] },
    valeur:"100€",
    plafond:"vélo . prix",
    lien:"https://www.ville-romagnat.fr/cadre-de-vie-urbanisme/developpement-durable/velo-electrique/" },
  "aides . cournon d'auvergne":{ remplace:"commune",
    titre:"Ville de Cournon-d’Auvergne",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '63124'",
        "vélo . électrique" ] },
    grille:{ assiette:"revenu fiscal de référence",
      tranches:[ { plafond:"469 €/mois",
          montant:"200€" },
        { plafond:"1028 €/mois",
          montant:"150€" },
        { plafond:"2233 €/mois",
          montant:"100€" } ] },
    plafond:"vélo . prix",
    lien:"http://www.cournon-auvergne.fr/Urbanisme-et-economie/Transports/Aide-pour-l-achat-d-un-velo-a-assistance-electrique" },
  "aides . colmar":{ remplace:"commune",
    titre:"Ville de Colmar",
    "applicable si":"localisation . code insee = '68066'",
    variations:[ { si:"vélo . électrique",
        alors:"200€" },
      { si:"vélo . mécanique",
        alors:"120€" },
      { sinon:"0€" } ],
    lien:"https://www.colmar.fr/sites/colmar.fr/files/documents/35-FE-participation-achat-velo-neuf_1.pdf" },
  "aides . avignon":{ remplace:"intercommunalité",
    titre:"Grand Avignon",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Grand Avignon (COGA)'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"400€",
    lien:"https://www.grandavignon.fr/fr/actualites/aide-lobtention-dun-vae" },
  "aides . luberon":{ remplace:"intercommunalité",
    titre:"Luberon Monts de Vaucluse",
    "applicable si":"localisation . epci = 'CA Luberon Monts de Vaucluse'",
    valeur:"30% * vélo . prix",
    plafond:{ variations:[ { si:{ "toutes ces conditions":[ "vélo . électrique",
              "vélo . prix <= 2500€" ] },
          alors:"300€" },
        { si:{ "toutes ces conditions":[ "vélo . mécanique",
              "vélo . prix <= 1000€" ] },
          alors:"200€" },
        { sinon:"0€" } ] },
    lien:"https://www.luberonmontsdevaucluse.fr/agglomeration/subvention-velo" },
  "aides . charenton":{ remplace:"commune",
    titre:"Ville de Charenton",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '94018'",
        "revenu fiscal de référence <= 15000 €/an",
        "vélo . électrique ou mécanique" ] },
    valeur:"50% * vélo . prix",
    plafond:"200€",
    lien:"https://www.charenton.fr/velo/velo_pass-velo.php" },
  "aides . pau":{ remplace:"intercommunalité",
    titre:"Pau Béarn Pyrénées Mobilité",
    "applicable si":"localisation . epci = 'CA Pau Béarn Pyrénées'",
    valeur:"15% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"350€" },
        { si:"vélo . pliant",
          alors:"200€" },
        { si:"vélo . électrique",
          alors:"200€" },
        { sinon:"0€" } ] },
    lien:"https://www.pau.fr/article/aide-a-lachat-velo--profitez-dun-coup-de-pouce-pour-changer-de-braquet" },
  "aides . pays basque":{ remplace:"intercommunalité",
    titre:"Agglomération Pays Basque",
    "applicable si":"localisation . epci = 'CA du Pays Basque'",
    variations:[ { si:"vélo . cargo électrique",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"430 €/mois",
                montant:{ valeur:"30% * vélo . prix",
                  plafond:"1000€" } },
              { plafond:"620 €/mois",
                montant:{ valeur:"30% * vélo . prix",
                  plafond:"900€" } },
              { plafond:"1200 €/mois",
                montant:{ valeur:"20% * vélo . prix",
                  plafond:"800€" } } ] } } },
      { si:"vélo . cargo",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"430 €/mois",
                montant:{ valeur:"30% * vélo . prix",
                  plafond:"700€" } },
              { plafond:"620 €/mois",
                montant:{ valeur:"30% * vélo . prix",
                  plafond:"600€" } },
              { plafond:"1200 €/mois",
                montant:{ valeur:"20% * vélo . prix",
                  plafond:"400€" } } ] } } },
      { si:"vélo . électrique",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"430 €/mois",
                montant:{ valeur:"60% * vélo . prix",
                  plafond:"600€" } },
              { plafond:"620 €/mois",
                montant:{ valeur:"50% * vélo . prix",
                  plafond:"500€" } },
              { plafond:"1200 €/mois",
                montant:{ valeur:"30% * vélo . prix",
                  plafond:"300€" } } ] } } },
      { si:"vélo . pliant",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"430 €/mois",
                montant:{ valeur:"50% * vélo . prix",
                  plafond:"300€" } },
              { plafond:"620 €/mois",
                montant:{ valeur:"40% * vélo . prix",
                  plafond:"250€" } },
              { plafond:"1200 €/mois",
                montant:{ valeur:"30% * vélo . prix",
                  plafond:"200€" } } ] } } } ],
    lien:"https://www.velo-paysbasque.fr/fr/pages/demande-de-subvention-velo-assistance-electrique" },
  "aides . grand lac":{ remplace:"intercommunalité",
    titre:"Grand Lac Communauté d'agglomération",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Grand Lac'",
        "vélo . électrique" ] },
    valeur:"150€",
    lien:"https://grand-lac.fr/au-quotidien/services-a-la-population/deplacements/le-velo" },
  "aides . aix les bains":{ remplace:"commune",
    titre:"Ville d’Aix-les-Bains",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '73008'",
        "vélo . électrique" ] },
    valeur:"250€",
    plafond:"vélo . prix",
    lien:"https://www.aixlesbains.fr/Cadre-de-vie/Transports-et-deplacements/A-velo/Aides-financieres-pour-se-deplacer-a-velo" },
  "aides . bourget-du-lac":{ remplace:"commune",
    titre:"Ville du Bourget-du-Lac",
    "applicable si":"localisation . code insee = '73051'",
    variations:[ { si:"vélo . électrique",
        alors:{ somme:[ "200€",
            { "applicable si":"revenu fiscal de référence <= 13489 €/an",
              valeur:"200€" } ] } },
      { si:"vélo . cargo",
        alors:"200€" },
      { sinon:"0€" } ],
    lien:"https://www.lebourgetdulac.fr/actualites/le-bourget-du-lac-sengage-pour-le-velo-a-assistance-electrique/" },
  "aides . la motte servolex":{ remplace:"commune",
    titre:"Ville de La Motte Servolex",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '73179'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . pliant" ] } ] },
    valeur:"20% * vélo . prix",
    plafond:"150€",
    lien:"https://www.mairie-lamotteservolex.fr/vos-demarches/subventions-eco-citoyennes-la-motte-servolex/" },
  "aides . ardenne":{ remplace:"intercommunalité",
    titre:"Ardenne Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Ardenne Métropole'",
        "vélo . électrique ou mécanique" ] },
    variations:[ { si:"vélo . fabriqué en france",
        alors:{ valeur:"40% * vélo . prix",
          plafond:"300€" } },
      { sinon:{ valeur:"33% * vélo . prix",
          plafond:"200€" } } ],
    lien:"https://ardenne-metropole.fr/storage/2021/04/Plaquette-subvention-v2.pdf" },
  "aides . erdregesvres":{ remplace:"intercommunalité",
    titre:"Communauté de communes d’Erdre et Gesvres",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC d’Erdre et Gesvres'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"100€",
    lien:"https://www.cceg.fr/vos-services/faciliter-et-simplifier-vos-deplacements/bonus-velo-4559.html" },
  "aides . cote d'or":{ remplace:"département",
    titre:"Département Côte d’Or",
    "applicable si":{ "toutes ces conditions":[ "localisation . département = '21'",
        "vélo . électrique" ] },
    valeur:{ variations:[ { si:"vélo assemblé ou produit localement",
          alors:"350€" },
        { sinon:"250€" } ] },
    plafond:"vélo . prix",
    lien:"https://www.cotedor.fr/actualite/une-aide-de-250-eu-pour-lacquisition-dun-velo-electrique" },
  "aides . cote d'or . vélo assemblé ou produit localement":{ question:"Le vélo est-il assemblé ou produit en Côte-d’Or ?",
    type:"booléen",
    "par défaut":"non" },
  "aides . lot":{ remplace:"département",
    titre:"Département du Lot",
    "applicable si":{ "toutes ces conditions":[ "localisation . département = '46'",
        "vélo . électrique" ] },
    valeur:{ variations:[ { si:"ménage imposable",
          alors:"300€" },
        { sinon:"400€" } ] },
    plafond:"40% * vélo . prix",
    lien:"https://lot.fr/vehicules-et-velos-electriques" },
  "aides . sophia antipolis":{ remplace:"intercommunalité",
    titre:"Communauté d’Agglomération Sophia Antipolis",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA de Sophia Antipolis'",
        "vélo . électrique ou mécanique" ] },
    valeur:"25% * vélo . prix",
    plafond:{ grille:{ assiette:"revenu fiscal de référence",
        tranches:[ { plafond:"1200 €/mois",
            montant:"300€" },
          { plafond:"1600 €/mois",
            montant:"200€" },
          { plafond:"2000 €/mois",
            montant:"100€" } ] } },
    lien:"https://www.agglo-sophiaantipolis.fr/vivre-et-habiter/se-deplacer/le-velo/demande-subvention-aide-a-lacquisition" },
  "aides . mougins":{ remplace:"commune",
    titre:"Ville de Mougins",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '06085'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"300€",
    lien:"https://www.espace-citoyens.net/mougins/espace-citoyens/Demande/NouvelleDemande/SUBV/D_SUBVAE" },
  "aides . mandelieu":{ remplace:"commune",
    titre:"Ville de Mandelieu-La Napoule",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '06079'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"revenu fiscal de référence <= 13489 €/an",
          alors:"150€" },
        { sinon:"100€" } ] },
    lien:"https://www.mandelieu.fr/services-publics/transports/plan-velo.php" },
  "aides . pantin":{ remplace:"commune",
    titre:"Ville de Pantin",
    "applicable si":"localisation . code insee = '93055'",
    description:"La ville de Pantin propose une aide forfaitaire pour l’achat de tout type de\nvélo neuf ou d’occasion. À noter que la demande de subvention est soumise à\nl’approbation du Conseil municipal et que plusieurs mois peuvent s’écouler\navant le versement de la subvention.\n",
    variations:[ { si:"vélo . électrique",
        alors:"200€" },
      { si:"vélo . mécanique",
        alors:"100€" },
      { sinon:"0€" } ],
    plafond:"vélo . prix",
    lien:"https://pratique.pantin.fr/deplacement-et-stationnement/transports-alternatifs-velo" },
  "aides . vaucresson":{ remplace:"commune",
    titre:"Ville de Vaucresson",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '92076'",
        "vélo . motorisation" ] },
    valeur:"150€",
    lien:"http://www.vaucresson.fr/Mobilites.aspx" },
  "aides . courbevoie":{ remplace:"commune",
    titre:"Ville de Courbevoie",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '92026'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . motorisation" ] } ] },
    variations:[ { si:"revenu fiscal de référence < 20000 €/an",
        alors:"25% * vélo . prix" },
      { si:"revenu fiscal de référence < 40000 €/an",
        alors:"20% * vélo . prix" },
      { sinon:"15% * vélo . prix" } ],
    plafond:"300€",
    lien:"https://www.ville-courbevoie.fr/1844/subvention-pour-l-achat-d-un-velo-electrique.htm" },
  "aides . mons en baroeul":{ remplace:"commune",
    titre:"Ville de Mons en Barœul",
    "applicable si":"localisation . code insee = '59410'",
    description:"La ville de Mons en Barœul offre une aide à l’achat d’un $vélo\njusqu’à $plafond pour ses habitants.\nNote: Les vélos dédiés exclusivement à des activités de loisirs ne sont pas\néligibles (BMX, VTT, vélo de course)\n",
    plafond:{ valeur:{ nom:"$plafond",
        variations:[ { si:"vélo . électrique",
            alors:"400 €" },
          { sinon:"200 €" } ] } },
    variations:[ { si:"vélo . électrique",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"851 €/mois",
                montant:{ valeur:"40% * vélo . prix",
                  plafond:"400 €" } },
              { plafond:"1300 €/mois",
                montant:{ valeur:"30% * vélo . prix",
                  plafond:"300€" } },
              { plafond:"1500 €/mois",
                montant:{ valeur:"20% * vélo . prix",
                  plafond:"200€" } },
              { plafond:"1800 €/mois",
                montant:{ valeur:"10% * vélo . prix",
                  plafond:"100€" } } ] } } },
      { si:"vélo . mécanique",
        alors:{ grille:{ assiette:"revenu fiscal de référence",
            tranches:[ { plafond:"851 €/mois",
                montant:{ valeur:"50% * vélo . prix",
                  plafond:"200€" } },
              { plafond:"1124 €/mois",
                montant:{ valeur:"25% * vélo . prix",
                  plafond:"100€" } } ] } } },
      { sinon:"0€" } ],
    lien:"https://www.monsenbaroeul.fr/vivre-mons-en-baroeul/se-deplacer/demander-ma-prime-velo" },
  "aides . la madeleine":{ remplace:"commune",
    titre:"Ville de La Madeleine",
    "applicable si":"localisation . code insee = '59368'",
    description:"Note: Les vélos pour enfant (inférieur à 26 pouces) et les modèles de vélos dédiés exclusivement\n à des activités de loisirs ne sont pas subventionnés (ex : BMX, vélo de piste, vélo de course haut de gamme,…)\n",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"250 €" },
        { si:"vélo . cargo",
          alors:"250 €" },
        { si:"vélo . mécanique",
          alors:"150 €" },
        { sinon:"0 €" } ] },
    lien:"https://www.ville-lamadeleine.fr/formulaires/transition-ecologique-aides-municipales" },
  "aides . nevers":{ remplace:"intercommunalité",
    titre:"Nevers Agglomération",
    "applicable si":"localisation . epci = 'CA de Nevers'",
    valeur:"30% * vélo . prix",
    plafond:{ variations:[ { si:{ "toutes ces conditions":[ "vélo . électrique",
              "vélo . prix <= 1650 €" ] },
          alors:"150 €" },
        { si:{ "toutes ces conditions":[ "vélo . mécanique",
              "vélo . prix <= 500 €" ] },
          alors:"75 €" },
        { si:{ "toutes ces conditions":[ "vélo . motorisation",
              "vélo . prix <= 500 €" ] },
          alors:"150 €" },
        { sinon:"0 €" } ] },
    lien:"https://www.nevers.fr/actualites/aide-a-lacquisition-dun-velo-2022" },
  "aides . aurillac":{ remplace:"intercommunalité",
    titre:"Vélo'Cab - Aurillac",
    description:"La communauté d’agglomération propose une subvention pour l’achat d’un vélo\nélectrique. Cette subvention est conditionné au fait d’avoir loué un vélo\nélectrique auprès de la Stabus pendant au moins 3 mois consécutifs\n",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Bassin d’Aurillac'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"300€",
    lien:"https://www.stabus.fr/fr/velocab/" },
  "aides . terre des 2 caps":{ remplace:"intercommunalité",
    titre:"Terre des 2 caps",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC de la Terre des Deux Caps'",
        "vélo . électrique" ] },
    valeur:"40% * vélo . prix",
    plafond:"250€",
    lien:"http://www.terredes2caps.fr/" },
  "aides . carvin":{ remplace:"commune",
    titre:"Ville de Carvin",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '62215'",
        "vélo . électrique ou mécanique" ] },
    valeur:"75% * vélo . prix",
    plafond:"300€",
    lien:"http://www.carvin.fr/carvinfr/actualites/2021/prime-velo.html" },
  "aides . les herbiers":{ remplace:"intercommunalité",
    titre:"Pays des Herbiers",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC du Pays des Herbiers'",
        "vélo . électrique" ] },
    valeur:"15% * vélo . prix",
    plafond:"200€",
    lien:"https://www.paysdesherbiers.fr/2-le-velo/" },
  "aides . riviera francaise":{ remplace:"intercommunalité",
    titre:"Riviera Française",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA de la Riviera Française'",
        "vélo . électrique" ] },
    valeur:"150€",
    plafond:{ valeur:"vélo . prix",
      abattement:"aides . commune" },
    lien:"https://www.riviera-francaise.fr/les-actualites/item/236-prime-pour-l-achat-d-un-velo-electrique-il-est-encore-temps-d-en-profiter" },
  "aides . frejus":{ remplace:"commune",
    titre:"Ville de Fréjus",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '83061'",
        "vélo . électrique" ] },
    valeur:"vélo . prix",
    plafond:"200 €",
    lien:"https://www.ville-frejus.fr/ma-ville/valorisation-et-preservation/dossier-de-demande-daide-a-lachat-dun-vae/" },
  "aides . orléans":{ remplace:"intercommunalité",
    titre:"Orléans Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Orléans Métropole'",
        "revenu fiscal de référence <= 2000 €/mois",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo" ] } ] },
    valeur:"25% * vélo . prix",
    plafond:"300€",
    lien:"https://www.orleans-metropole.fr/actualites/detail/il-est-temps-de-passer-au-velo-electrique" },
  "aides . chalette-sur-loing":{ remplace:"commune",
    titre:"Ville de Chalette-sur-Loing",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '45068'",
        "vélo . électrique" ] },
    valeur:"15% * vélo . prix",
    plafond:"250€",
    lien:"https://www.ville-chalette.fr/Une-aide-a-l-achat-d-un-Velo-a.html" },
  "aides . reims":{ remplace:"commune",
    titre:"Ville de Reims",
    "applicable si":"localisation . code insee = '51454'",
    valeur:{ variations:[ { si:"vélo . cargo électrique",
          alors:{ valeur:"25% * vélo . prix",
            plafond:"250€" } },
        { si:"vélo . électrique",
          alors:{ valeur:"25% * vélo . prix",
            plafond:"150€" } },
        { si:"vélo . mécanique",
          alors:{ valeur:"50% * vélo . prix",
            plafond:"80€" } },
        { sinon:"0€" } ] },
    lien:"https://www.reims.fr/qualite-de-vie-environnement/stationnement-et-deplacements/operation-aide-a-lachat-dun-velo" },
  "aides . grand reims":{ remplace:"intercommunalité",
    titre:"Grand Reims Communauté urbaine",
    "applicable si":"localisation . epci = 'CU du Grand Reims'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:"500€" },
        { si:"vélo . électrique",
          alors:"300€" },
        { si:"vélo . pliant",
          alors:"300€" },
        { sinon:"0€" } ] },
    lien:"https://www.grandreims.fr/les-services/deplacements-et-mobilites/operation-aide-a-lachat-dun-velo-a-assistance-electrique-14525.html" },
  "aides . annecy":{ remplace:"intercommunalité",
    titre:"Grand Annecy",
    "applicable si":"localisation . epci = 'CA du Grand Annecy'",
    variations:[ { si:{ "toutes ces conditions":[ "vélo . cargo électrique",
            "vélo . prix >= 700€",
            "vélo . prix <= 5000€" ] },
        alors:{ variations:[ { si:"revenu fiscal de référence <= 18000 €/an",
              alors:"600€" },
            { sinon:"400€" } ] } },
      { si:{ "toutes ces conditions":[ "vélo . électrique",
            "vélo . prix >= 700€",
            "vélo . prix <= 3000€" ] },
        alors:{ variations:[ { si:"revenu fiscal de référence <= 18000 €/an",
              alors:"400€" },
            { sinon:"200€" } ] } },
      { si:{ "toutes ces conditions":[ "vélo . cargo",
            "vélo . prix >= 200€",
            "vélo . prix <= 2400€" ] },
        alors:{ variations:[ { si:"revenu fiscal de référence <= 18000 €/an",
              alors:"300€" },
            { sinon:"200€" } ] } },
      { si:{ "toutes ces conditions":[ "vélo . pliant",
            "vélo . prix >= 200 €",
            "vélo . prix <= 1500 €",
            "revenu fiscal de référence <= 13489 €/an" ] },
        alors:"150€" },
      { si:{ "toutes ces conditions":[ "vélo . mécanique simple",
            "vélo . prix >= 200 €",
            "vélo . prix <= 1000 €",
            "revenu fiscal de référence <= 13489 €/an" ] },
        alors:"150€" } ],
    lien:"https://aide-velo.grandannecy.fr/" },
  "aides . genevois":{ remplace:"intercommunalité",
    titre:"Communauté de communes du Genevois",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC du Genevois'",
        "vélo . électrique" ] },
    valeur:"250€",
    lien:"https://www.cc-genevois.fr/fr/vie-pratique-et-services/vous-deplacer/velo-ou-pied" },
  "aides . évian-les-bains":{ remplace:"commune",
    titre:"Ville d’Évian-les-Bains",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '74119'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo",
            "vélo . motorisation" ] } ] },
    valeur:"20% * vélo . prix",
    plafond:"400€",
    lien:"https://forms.gle/FbFMrPU4AYiTqTAg9" },
  "aides . marignier":{ remplace:"commune",
    titre:"Ville de Marignier",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '74164'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . pliant" ] } ] },
    valeur:"100€",
    plafond:"vélo . prix",
    lien:"http://www.marignier.fr/velo_electrique_aide.news" },
  "aides . combloux":{ remplace:"commune",
    titre:"Commune de Combloux",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '74083'",
        "vélo . électrique" ] },
    valeur:"200€",
    plafond:"80% * vélo . prix",
    lien:"https://mairie-combloux.fr/aide-a-lachat-dun-velo-a-assistance-electrique/" },
  "aides . angers":{ remplace:"intercommunalité",
    titre:"Angers Loire Métropole",
    "applicable si":"localisation . epci = 'CU Angers Loire Métropole'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:"400€" },
        { si:"vélo . cargo",
          alors:"100€" },
        { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . mécanique",
          alors:"50€" },
        { sinon:"0€" } ] },
    lien:"https://www.angersloiremetropole.fr/mon-quotidien/mobilites/velo/aide-a-l-achat-d-un-velo-neuf/index.html" },
  "aides . brissac loire aubance":{ remplace:"intercommunalité",
    titre:"Brissac Loire Aubance",
    "applicable si":"localisation . epci = 'CC Loire Layon Aubance'",
    variations:[ { si:"vélo . cargo électrique",
        alors:"350€" },
      { si:"vélo . électrique",
        alors:"200€" },
      { si:"vélo . motorisation",
        alors:"200€" },
      { sinon:"0€" } ],
    plafond:"vélo . prix",
    lien:"https://www.brissacloireaubance.fr/actualites/une-nouvelle-aide-de-la-cclla-pour-lachat-de-velo-a-assistance-electrique/" },
  "aides . châtellrault":{ remplace:"intercommunalité",
    titre:"Grand Châtellerault",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Grand Châtellerault'",
        "vélo . électrique" ] },
    variations:[ { si:{ nom:"ancien abonné vélibleu",
          type:"booléen",
          question:"Êtes-vous un ancien abonné Vélibleu d’au moins 6 mois avant le 31 décembre 2021 ?",
          "par défaut":"non" },
        alors:"300€" },
      { sinon:"200€" } ],
    lien:"https://www.ville-chatellerault.fr/a-votre-service/deplacements/aide-%C3%A0-l-achat-de-v%C3%A9lo" },
  "aides . pays de l'or":{ remplace:"intercommunalité",
    titre:"Pays de l’Or",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Pays de l’Or'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo" ] } ] },
    valeur:"20% * vélo . prix",
    plafond:"200€",
    lien:"https://www.paysdelor.fr/lagglo-vous-aide-pour-lachat-dun-velo-a-assistance-electrique-vae-cargo-ou-adapte/" },
  "aides . annemasse":{ remplace:"intercommunalité",
    titre:"Annemasse Agglo",
    "applicable si":"localisation . epci = 'CA Annemasse-Les Voirons-Agglomération'",
    valeur:{ variations:[ { si:{ "toutes ces conditions":[ "vélo . cargo",
              "vélo . prix >= 1000€" ] },
          alors:"300€" },
        { si:{ "toutes ces conditions":[ "vélo . électrique",
              "vélo . prix >= 750€",
              "vélo . prix <= 4500€" ] },
          alors:"300€" },
        { si:{ "toutes ces conditions":[ "vélo . mécanique",
              "vélo . prix >= 200€" ] },
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"https://www.annemasse-agglo.fr/infos-et-loisirs/actualites/prime-velo-demandez-laide-en-quelques-clics" },
  "aides . montlucon":{ remplace:"intercommunalité",
    titre:"Montluçon Communauté",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Montluçon Communauté'",
        "vélo . électrique",
        "vélo . prix <= 2500€" ] },
    valeur:"vélo . prix",
    plafond:"200 €",
    lien:"https://vae.montlucon-communaute.com/" },
  "aides . cotentin":{ remplace:"intercommunalité",
    titre:"Cap Cotentin",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Cotentin'",
        "vélo . électrique" ] },
    valeur:"15% * vélo . prix",
    plafond:"150 €",
    lien:"https://www.capcotentin.fr/velo/" },
  "aides . granville":{ remplace:"commune",
    titre:"Ville de Granville",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '50218'",
        "vélo . électrique ou mécanique" ] },
    variations:[ { si:"revenu fiscal de référence <= 13488€/an",
        alors:{ variations:[ { si:"vélo . électrique",
              alors:"600€" },
            { sinon:"250€" } ] } },
      { si:"revenu fiscal de référence <= 20230€/an",
        alors:{ variations:[ { si:"vélo . électrique",
              alors:"250€" },
            { sinon:"100€" } ] } },
      { si:"revenu fiscal de référence <= 26972€/an",
        alors:"100€" },
      { sinon:"0€" } ],
    plafond:{ variations:[ { si:"revenu fiscal de référence <= 13488€/an",
          alors:"75% * vélo . prix" },
        { sinon:"50% * vélo . prix" } ] },
    lien:"https://www.ville-granville.fr/vivre-au-quotidien-demarches-services/se-deplacer/aide-a-lachat-dun-velo/" },
  "aides . la rochelle":{ remplace:"intercommunalité",
    titre:"Ville de La Rochelle - Yélo",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA de La Rochelle'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo" ] } ] },
    variations:[ { si:"revenu fiscal de référence <= 450 €/mois",
        alors:{ valeur:"50% * vélo . prix",
          plafond:"400€" } },
      { si:"revenu fiscal de référence <= 650 €/mois",
        alors:{ valeur:"40% * vélo . prix",
          plafond:"300€" } },
      { si:"revenu fiscal de référence <= 750 €/mois",
        alors:{ valeur:"30% * vélo . prix",
          plafond:"200€" } },
      { sinon:"0€" } ],
    lien:"https://yelo.agglo-larochelle.fr/aide-a-lachat-dun-vae/" },
  "aides . blois":{ remplace:"intercommunalité",
    titre:"Agglopolys",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA de Blois ’’Agglopolys’’'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"400€",
    lien:"https://www.agglopolys.fr/1247-le-velo-a-assistance-electrique.htm" },
  "aides . epinal":{ remplace:"intercommunalité",
    titre:"Agglomération Épinal",
    "applicable si":"localisation . epci = 'CA d’Epinal'",
    valeur:"20% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:"300€" },
        { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . motorisation",
          alors:"200€" },
        { sinon:"0€" } ] },
    lien:"https://www.agglo-epinal.fr/se-deplacer/velo/subvention-a-lachat-dun-vae/" },
  "aides . vannes":{ remplace:"intercommunalité",
    titre:"Vannes Agglomération",
    "applicable si":"localisation . epci = 'CA Golfe du Morbihan - Vannes Agglomération'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:"800€" },
        { si:"vélo . cargo",
          alors:"400€" },
        { si:"vélo . électrique",
          alors:{ variations:[ { si:"revenu fiscal de référence <= 1200 €/mois",
                alors:"300€" },
              { si:"revenu fiscal de référence <= 1400 €/mois",
                alors:"200€" },
              { sinon:"0€" } ] } },
        { sinon:"0€" } ] },
    lien:"https://www.golfedumorbihan-vannesagglomeration.bzh/aides-la-pratique-du-velo" },
  "aides . quéven":{ remplace:"commune",
    titre:"Ville de Quéven",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '56185'",
        "vélo . électrique ou mécanique" ] },
    valeur:"30% * vélo . prix",
    plafond:"100€",
    lien:"https://www.queven.com/vivre-a-queven/transports/demande-de-subvention-velo/" },
  "aides . rochefort":{ remplace:"intercommunalité",
    titre:"Agglomération Rochefort",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Rochefort Océan'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo",
            "vélo . pliant" ] } ] },
    valeur:"vélo . prix",
    plafond:{ variations:[ { si:"revenu fiscal de référence > 760€/mois",
          alors:"50€" },
        { si:"revenu fiscal de référence > 500€/mois",
          alors:"100€" },
        { si:"revenu fiscal de référence > 380€/mois",
          alors:"150€" },
        { sinon:"200€" } ] },
    lien:"https://www.agglo-rochefortocean.fr/velo-assistance-electrique-velos-pliants-cargos-aide-lacquisition" },
  "aides . saintes":{ remplace:"intercommunalité",
    titre:"Saintes Communauté d'agglomération",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA de Saintes'",
        "vélo . électrique" ] },
    valeur:"200€",
    lien:"https://www.agglo-saintes.fr/l-agglo-au-quotidien/transports-et-mobilites/530-aide-a-l-achat-d-un-velo-a-assistance-electrique.html" },
  "aides . yvetot normandie":{ remplace:"intercommunalité",
    titre:"Yvetot Normandie",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC Yvetot Normandie'",
        "vélo . électrique ou mécanique" ] },
    valeur:"30% * vélo . prix",
    plafond:"200€",
    lien:"https://www.yvetot-normandie.fr/vivre-in-yvetot-normandie/subventions/plan-velo-aide-a-lachat-de-velo/" },
  "aides . arcachon":{ remplace:"commune",
    titre:"Ville d’Arcachon",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '33009'",
        "vélo . électrique" ] },
    valeur:"vélo . prix",
    plafond:"200€",
    lien:"https://www.ville-arcachon.fr/velo-arcachon/" },
  "aides . bourges":{ remplace:"intercommunalité",
    titre:"Bourges Plus",
    "applicable si":"localisation . epci = 'CA Bourges Plus'",
    valeur:"50% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"500€" },
        { si:"vélo . pliant",
          alors:"300€" },
        { si:"vélo . électrique",
          alors:"300€" },
        { si:"vélo . mécanique",
          alors:"150€" },
        { sinon:"0€" } ] },
    lien:"https://www.agglo-bourgesplus.fr/site/aide-achat-velo" },
  "aides . tulle":{ remplace:"intercommunalité",
    titre:"Tulle Agglo",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Tulle Agglo'",
        "vélo . électrique" ] },
    valeur:"200€",
    lien:"https://www.agglo-tulle.fr/vie-pratique/mobilites/transports/velo/aide-achat-vae" },
  "aides . corrèze":{ remplace:"commune",
    titre:"Ville de Corrèze",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '19062'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://www.mairie-de-correze.fr/app/download/16358677024/Bulletin+Municipal+Janvier+2022.pdf?t=1641302365#page=19" },
  "aides . montauban":{ remplace:"intercommunalité",
    titre:"Grand-Montauban",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Grand Montauban'",
        "vélo . cargo" ] },
    valeur:"vélo . prix",
    plafond:"250€",
    lien:"https://www.montauban.com/au-quotidien/mobilite-et-stationnement/velos-et-pistes-cyclables" },
  "aides . mont de marsan":{ remplace:"intercommunalité",
    titre:"Mont de Marsan Agglo",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Mont de Marsan Agglomération'",
        "vélo . électrique" ] },
    valeur:"250€",
    lien:"http://www.montdemarsan-agglo.fr/agglo/document?id=2682&id_attribute=48&usg=AOvVaw1SVEDZSqj0LRmmUyyGkc_n" },
  "aides . bourg en bresse":{ remplace:"commune",
    titre:"Ville de Bourg-en-Bresse",
    "applicable si":"localisation . code insee = '01053'",
    valeur:"vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"400€" },
        { si:"vélo . électrique",
          alors:"300€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"https://www.bourgenbresse.fr/actualite/1248/225-aide-a-l-achat-d-un-velo-pour-les-burgiens.htm" },
  "aides . divonne-les-bains":{ remplace:"commune",
    titre:"Ville de Divonne-les-Bains",
    "applicable si":"localisation . code insee = '01143'",
    valeur:"50% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . cargo",
          alors:"200€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"http://www.divonnelesbains.fr/prime_a_l_achat_de_velos_a_divonne_les_bains.html" },
  "aides . valence romans":{ remplace:"intercommunalité",
    titre:"Valence Romans Déplacements",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Valence Romans Agglo'",
        "vélo . pliant" ] },
    valeur:"35% * vélo . prix",
    plafond:"150€",
    lien:"https://www.vrd-mobilites.fr/velo/#aide-achat-velo-pliant" },
  "aides . dieulefit-bourdeaux":{ remplace:"intercommunalité",
    titre:"Communauté de communes Dieulefit-Bourdeaux",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC Dieulefit-Bourdeaux'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"http://www.paysdedieulefit.info/ccpdj2/index.php/defi-climat/les-mobilites/aide-forfaitaire-pour-vae" },
  "aides . lorient":{ remplace:"intercommunalité",
    titre:"Lorient Agglomération",
    "applicable si":"localisation . epci = 'CA Lorient Agglomération'",
    valeur:"20% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"250€" },
        { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . pliant",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"https://www.lorient-agglo.bzh/actualites/toutes-les-actualites/actualite/news/une-prime-pour-encourager-lacquisition-dun-velo/" },
  "aides . la roche sur yon":{ remplace:"intercommunalité",
    titre:"La Roche-sur-Yon Agglomération",
    "applicable si":"localisation . epci = 'CA La Roche sur Yon - Agglomération'",
    variations:[ { si:"vélo . cargo",
        alors:{ valeur:"20% * vélo . prix",
          plafond:"400€" } },
      { si:{ "toutes ces conditions":[ "vélo . électrique",
            "vélo . prix <= 1500€" ] },
        alors:{ variations:[ { si:"entreprise adherente au pdie",
              alors:"200€" },
            { sinon:"100€" } ] } },
      { sinon:"0€" } ],
    lien:"https://www.larochesuryon.fr/services-infos-pratiques/transports-et-deplacements-durables/velos/" },
  "aides . la roche sur yon . entreprise adherente au pdie":{ question:"Êtes-vous salarié d’une entreprise adhérente au Plan de déplacement inter-entreprises (PDIE) ?",
    type:"booléen",
    "par défaut":"non" },
  "aides . cholet":{ remplace:"intercommunalité",
    titre:"Agglomération du Choletais",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Agglomération du Choletais'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"250€",
    lien:"https://www.cholet.fr/dossiers/dossier_5364_aide+velo+assistance+electrique.html" },
  "aides . laval":{ remplace:"intercommunalité",
    titre:"Laval Agglo",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Laval Agglomération'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"200€",
    lien:"https://www.agglo-laval.fr/utile-au-quotidien/transports-et-mobilites/lagglo-a-velo/prime-a-lachat-dun-velo-electrique" },
  "aides . ernée":{ remplace:"intercommunalité",
    titre:"L’Ernée Communauté de communes",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC de l’Ernée'",
        "vélo . électrique" ] },
    valeur:"10% * vélo . prix",
    plafond:"100€",
    lien:"https://www.lernee.fr/au-quotidien/mobilite/subvention-velo-electrique/" },
  "aides . saint-martin-de-crau":{ remplace:"commune",
    titre:"Saint-Martin-de-Crau",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '13097'",
        "vélo . électrique" ] },
    valeur:"15% * vélo . prix",
    plafond:"150€",
    lien:"https://www.saintmartindecrau.fr/-Prime-a-l-achat-d-un-velo-.html?&imprimer=oui" },
  "aides . brive":{ remplace:"intercommunalité",
    titre:"Agglo de Brive",
    description:"Aide sous forme d’un Chèque Vélo à demander avant d’acheter le vélo\n",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Bassin de Brive'",
        "vélo . électrique" ] },
    valeur:"30% * vélo . prix",
    plafond:"200€",
    lien:"http://www.donzenac.correze.net/data/uploads/actualites/aide-velos-elec.pdf" },
  "aides . pays de saint gilles":{ remplace:"intercommunalité",
    titre:"Pays de Saint-Gilles Croix de Vie",
    "applicable si":"localisation . epci = 'CC du Pays de Saint-Gilles-Croix-de-Vie'",
    variations:[ { si:"vélo . cargo",
        alors:{ valeur:"20% * vélo . prix",
          plafond:"350€" } },
      { si:"vélo . électrique",
        alors:{ valeur:"20% * vélo . prix",
          plafond:"300€" } },
      { si:"vélo . mécanique",
        alors:{ valeur:"50% * vélo . prix",
          plafond:"100€" } },
      { sinon:"0€" } ],
    lien:"https://www.payssaintgilles.fr/actualites/15-janvier-lancement-de-la-nouvelle-aide-a-lachat-de-velo/" },
  "aides . ville de talant":{ remplace:"commune",
    titre:"Ville de Talant",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '21617'",
        "vélo . électrique" ] },
    valeur:"20% * vélo . prix",
    plafond:"100€",
    lien:"https://www.talant.fr/content_page/item/222-prime_vae.html" },
  "aides . vendée grand littoral":{ remplace:"intercommunalité",
    titre:"Vendée Grand Littoral",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC Vendée Grand Littoral'",
        "vélo . électrique" ] },
    valeur:"20% * vélo . prix",
    plafond:"300€",
    lien:"https://www.vendeegrandlittoral.fr/aide-a-lachat-de-velo-a-assistance-electrique/" },
  "aides . pays des achards":{ remplace:"intercommunalité",
    titre:"Pays des Achards",
    "applicable si":"localisation . epci = 'CC du Pays des Achards'",
    variations:[ { si:"vélo . cargo",
        alors:{ valeur:"25% * vélo . prix",
          plafond:"300€" } },
      { si:{ "une de ces conditions":[ "vélo . électrique",
            "vélo . motorisation" ] },
        alors:{ valeur:"25% * vélo . prix",
          plafond:"200€" } },
      { si:"vélo . mécanique",
        alors:{ valeur:"25% * vélo . prix",
          plafond:"100€" } },
      { sinon:"0€" } ],
    lien:"https://www.cc-paysdesachards.fr/amenagement/mobilites/351-bonus-velo.html" },
  "aides . hem":{ remplace:"commune",
    titre:"Ville de Hem",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '59299'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"300 €",
    lien:"https://www.ville-hem.fr/cadre-de-vie/environnement/prime-a-lachat-dun-velo-ou-dune-trottinette/" },
  "aides . saint-omer":{ remplace:"intercommunalité",
    titre:"Pays de Saint-Omer",
    "applicable si":"localisation . epci = 'CA du Pays de Saint-Omer'",
    valeur:"20% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"150€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"http://demarches.paysdesaintomer.com/subvention-aide-a-lachat-dun-velo/" },
  "aides . comines":{ remplace:"commune",
    titre:"Ville de Comines",
    "applicable si":"localisation . code insee = '59152'",
    variations:[ { si:"vélo . électrique",
        alors:{ valeur:"50% * vélo . prix",
          plafond:"150€" } },
      { si:"vélo . mécanique",
        alors:{ valeur:"25% * vélo . prix",
          plafond:"250€" } },
      { sinon:"0€" } ],
    lien:"https://www.ville-comines.fr/vie-pratique/actualites/545-mobilite-douce-la-ville-de-comines-lance-une-aide-pour-l-achat-d-un-velo" },
  "aides . liévin":{ remplace:"commune",
    titre:"Ville de Liévin",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '62510'",
        "vélo . électrique" ] },
    valeur:"250€",
    plafond:"vélo . prix",
    lien:"https://www.lievin.fr/velo-ou-trottinette" },
  "aides . béthune":{ remplace:"commune",
    titre:"Pass Mobilité Béthunes",
    "applicable si":"localisation . code insee = '62119'",
    variations:[ { si:"vélo . électrique",
        alors:"200€" },
      { si:"vélo . mécanique",
        alors:"50€" },
      { sinon:"0€" } ],
    plafond:"vélo . prix",
    lien:"https://www.bethune.fr/actualites-109/le-pass-mobilite-est-disponible-3115.html?cHash=2cb2c65e61700dca65d6e79bce58cdfa" },
  "aides . baisieux":{ remplace:"commune",
    titre:"Ville de Baisieux",
    description:"Il est nécessaire de faire la demande auprès de la maire de Baisieux avant\nl’achat.\n",
    "applicable si":"localisation . code insee = '59044'",
    valeur:"20% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"200€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"https://www.mairie-baisieux.fr/aide-velo" },
  "aides . billy-berclau":{ remplace:"commune",
    titre:"Ville de Billy-Berclau",
    "applicable si":"localisation . code insee = '62132'",
    valeur:"20% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"100€" },
        { si:"vélo . mécanique",
          alors:"50€" },
        { sinon:"0€" } ] },
    lien:"https://www.billy-berclau.fr/blog/mairie/aide-municipale-pour-lachat-dun-velo/" },
  "aides . marquette-lez-lille":{ remplace:"commune",
    titre:"Ville de Marquette-lez-Lille",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '59386'",
        "vélo . électrique ou mécanique" ] },
    valeur:"50% * vélo . prix",
    plafond:"150€",
    lien:"https://www.marquettelezlille.fr/actualite/la-ville-subventionne-votre-achat-de-velo/" },
  "aides . gruson":{ remplace:"commune",
    titre:"Ville de Gruson",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '59275'",
        "vélo . électrique" ] },
    valeur:"vélo . prix",
    plafond:{ variations:[ { si:"revenu fiscal de référence <= 13489 €/an",
          alors:"200€" },
        { sinon:"100€" } ] },
    lien:"https://www.mairie-gruson.fr/environnement/developpement-durable/prime-velo-a-assistance-electrique" },
  "aides . dunkerque":{ remplace:"intercommunalité",
    titre:"Communauté urbaine de Dunkerque",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CU de Dunkerque'",
        "vélo . électrique ou mécanique" ] },
    valeur:"vélo . prix",
    plafond:"80€",
    lien:"https://www.communaute-urbaine-dunkerque.fr/fileadmin/Cud/documents/Subvention/habitat/aide/AideAchatVelo_flyer_A4_Ro.pdf" },
  "aides . flandre intérieure":{ remplace:"intercommunalité",
    titre:"Communauté de Communes de Flandre Intérieure",
    "applicable si":"localisation . epci = 'CC de Flandre Intérieure'",
    valeur:"20% * vélo . prix",
    plafond:{ somme:[ { variations:[ { si:"vélo . électrique",
              alors:"200€" },
            { si:"vélo . mécanique",
              alors:"100€" },
            { si:"vélo . motorisation",
              alors:"100€" },
            { sinon:"0€" } ] },
        { variations:[ { si:"vélo . cargo",
              alors:"100€" },
            { si:"vélo . pliant",
              alors:"50€" },
            { sinon:"0€" } ] } ] },
    lien:"https://cc-flandreinterieure.fr/fr/nw/574368/863449/renouvellement-de-laide-velo" },
  "aides . grande-synthe":{ remplace:"commune",
    titre:"Ville de Grande Synthe",
    "applicable si":"localisation . code insee = '59271'",
    variations:[ { si:"vélo . électrique",
        alors:"50% * vélo . prix" },
      { si:"vélo . mécanique",
        alors:"20% * vélo . prix" },
      { sinon:"0€" } ],
    plafond:"200€",
    lien:"https://www.ville-grande-synthe.fr/2020/05/20/dossier-daide-a-lachat-dun-velo/" },
  "aides . valenciennes":{ remplace:"intercommunalité",
    titre:"Valenciennes Métropole",
    "applicable si":"localisation . epci = 'CA Valenciennes Métropole'",
    valeur:"30% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"400€" },
        { si:"vélo . mécanique",
          alors:"150€" },
        { sinon:"0€" } ] },
    lien:"https://www.valenciennes-metropole.fr/competences/amenagement-du-territoire/mode-doux-mobilite/" },
  "aides . thiais":{ remplace:"commune",
    titre:"Ville de Thiais",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '94073'",
        "vélo . électrique" ] },
    valeur:"25% * vélo . prix",
    plafond:"200€",
    lien:"https://www.ville-thiais.fr/subvention-pour-lachat-dun-velo-electrique/" },
  "aides . nanterre":{ remplace:"commune",
    titre:"Ville de Nanterre",
    "applicable si":"localisation . code insee = '92050'",
    variations:[ { si:"vélo . mécanique simple",
        alors:{ variations:[ { si:"revenu fiscal de référence <= 8676 €/an",
              alors:{ valeur:"80% * vélo . prix",
                plafond:"400€" } },
            { si:"revenu fiscal de référence <= 21552 €/an",
              alors:{ valeur:"60% * vélo . prix",
                plafond:"300€" } },
            { si:"revenu fiscal de référence <= 31512 €/an",
              alors:{ valeur:"35% * vélo . prix",
                plafond:"210€" } },
            { sinon:"0€" } ] } },
      { si:"vélo . motorisation",
        alors:{ variations:[ { si:"revenu fiscal de référence <= 8676 €/an",
              alors:{ valeur:"60% * vélo . prix",
                plafond:"300€" } },
            { si:"revenu fiscal de référence <= 21552 €/an",
              alors:{ valeur:"50% * vélo . prix",
                plafond:"280€" } },
            { si:"revenu fiscal de référence <= 31512 €/an",
              alors:{ valeur:"40% * vélo . prix",
                plafond:"250€" } },
            { sinon:"0€" } ] } } ],
    lien:"https://www.nanterre.fr/1687-velo-les-dispositifs-d-aide.htm" },
  "aides . genneviliers":{ remplace:"commune",
    titre:"Ville de Genneviliers",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '92036'",
        "vélo . mécanique" ] },
    valeur:"100€",
    lien:"https://www.ville-gennevilliers.fr/671/cadre-de-vie/acces-transports-stationnement/aides-a-l-achat-d-un-velo.htm" },
  "aides . drancy":{ remplace:"commune",
    titre:"Ville de Drancy",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '93029'",
        "vélo . électrique" ] },
    variations:[ { si:"ménage imposable",
        alors:"200€" },
      { sinon:"100€" } ],
    lien:"https://www.drancy.fr/les-services-municipaux-et-les-demarches-administratives/annuaire-des-demarches-411/subvention-pour-l-achat-d-un-velo-electrique-1821.html?cHash=e554e270f39900d5ba8d0b528584d11c" },
  "aides . fontenay":{ remplace:"commune",
    titre:"Ville de Fontenay",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '94033'",
        "vélo . électrique" ] },
    valeur:"80€",
    plafond:"70% * vélo . prix",
    lien:"https://www.fontenay.fr/cadre-de-vie/deplacements/aide-velo-electrique-1278.html" },
  "aides . rives de moselle":{ remplace:"intercommunalité",
    titre:"Rives de Moselle",
    "applicable si":"localisation . epci = 'CC Rives de Moselle'",
    valeur:"25% * vélo . prix",
    plafond:{ variations:[ { si:{ "une de ces conditions":[ "vélo . électrique",
              "vélo . cargo",
              "vélo . pliant" ] },
          alors:{ variations:[ { si:"vélo . fabriqué en france",
                alors:"300€" },
              { sinon:"200€" } ] } },
        { si:"vélo . mécanique simple",
          alors:{ variations:[ { si:"vélo . fabriqué en france",
                alors:"150€" },
              { sinon:"100€" } ] } },
        { sinon:"0€" } ] },
    lien:"https://www.rivesdemoselle.fr/Aide-a-l-achat-pour-un-velo-avec-ou-sans-assistance-electrique.html" },
  "aides . thionville":{ remplace:"commune",
    titre:"Ville de Thionville",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '57672'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://www.thionville.fr/fr/content/demande-de-subvention-pour-l-acquisition-dun-v-lo-assistance-lectrique-vae" },
  "aides . betheny":{ remplace:"commune",
    titre:"Ville de Bétheny",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '51055'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://ville-betheny.fr/cadre-de-vie/subvention-velo-a-assistance-electrique-vae/article/subvention-velo-a-assistance-electrique-vae" },
  "aides . épernay":{ remplace:"commune",
    titre:"Ville d’Épernay",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '51230'",
        "vélo . électrique" ] },
    valeur:"50% * vélo . prix",
    plafond:"150€",
    lien:"https://www.epernay.fr/sites/epernay/files/document/article/reglement_sub_velo_2021.pdf" },
  "aides . brest":{ remplace:"intercommunalité",
    titre:"Brest Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'Brest Métropole'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo" ] } ] },
    variations:[ { si:"revenu fiscal de référence <= 13489 €/an",
        alors:{ valeur:"50% * vélo . prix",
          plafond:"500€" } },
      { si:"revenu fiscal de référence <= 20000 €/an",
        alors:{ valeur:"40% * vélo . prix",
          plafond:"400€" } },
      { si:"revenu fiscal de référence <= 26350 €/an",
        alors:{ valeur:"30% * vélo . prix",
          plafond:"200€" } },
      { sinon:"0€" } ],
    lien:"https://www.brest.fr/mes-demarches/environnement/demander-la-subvention-velo-a-assistance-electrique-7043.html" },
  "aides . plouzané":{ remplace:"commune",
    titre:"Ville de Plouzané",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '29212'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"http://www.ville-plouzane.fr/index.php/fr/toute-l-actualite/1074-aide-a-l-achat-vae" },
  "aides . gouesnou":{ remplace:"commune",
    titre:"Ville de Gouesnou",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '29061'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://www.gouesnou.bzh/actualites/prime-a-lachat-dun-velo-a-assistance-electrique/" },
  "aides . pougastel-daoulas":{ remplace:"commune",
    titre:"Ville de Plougastel-Daoulas",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '29189'",
        "vélo . électrique" ] },
    variations:[ { si:"revenu fiscal de référence <= 13489 €/an",
        alors:"200 €" },
      { sinon:"150 €" } ],
    plafond:"vélo . prix",
    lien:"https://www.brest.fr/mes-demarches/environnement/demander-la-subvention-velo-a-assistance-electrique-7043.html" },
  "aides . saint-pol-de-léon":{ remplace:"commune",
    titre:"Ville de Saint-Pol-de-Léon",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '29259'",
        "vélo . électrique" ] },
    valeur:"100€",
    lien:"https://www.saintpoldeleon.fr/la-ville-vous-aide-pour-l-achat-d" },
  "aides . saint-malo":{ remplace:"intercommunalité",
    titre:"Pays de Saint Malo Agglomération",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Pays de Saint Malo Agglomération'",
        "vélo . électrique" ] },
    valeur:"10% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo électrique",
          alors:"400€" },
        { sinon:"120€" } ] },
    lien:"https://www.stmalo-agglomeration.fr/aide-achat-velo-electrique.html" },
  "aides . saint-brieuc armor":{ remplace:"intercommunalité",
    titre:"Saint-Brieuc Armor Agglomération",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Saint-Brieuc Armor Agglomération'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo" ] } ] },
    valeur:"25% * vélo . prix",
    plafond:"150€",
    lien:"https://www.saintbrieuc-armor-agglo.bzh/information/actualites/aide-a-lachat-de-votre-velo-electrique-ou-velo-cargo-en-2022-2438" },
  "aides . lannion-trégor":{ remplace:"intercommunalité",
    titre:"Lannion-Trégor Communauté",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Lannion-Trégor Communauté'",
        "vélo . électrique" ] },
    valeur:"10% * vélo . prix",
    plafond:"100€",
    lien:"https://www.lannion-tregor.com/fr/deplacements/les-mobilites-electriques/les-aides-a-l-acquisition.html" },
  "aides . perros-guirec":{ remplace:"commune",
    titre:"Ville de Perros-Guirec",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '22168'",
        "vélo . électrique" ] },
    valeur:"10% * vélo . prix",
    plafond:"100€",
    lien:"http://ville.perros-guirec.com/ma-ville/vie-quotidienne/les-transports/en-velo/aide-a-l-acquisition-d-un-velo-a-assistance-electrique.html" },
  "aides . morlaix":{ remplace:"intercommunalité",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Morlaix Communauté'",
        "vélo . électrique" ] },
    variations:[ { si:"revenu fiscal de référence <= 13489 €/an",
        alors:"500 €" },
      { si:"revenu fiscal de référence <= 20234 €/an",
        alors:"200 €" },
      { sinon:"100 €" } ],
    plafond:"vélo . prix",
    lien:"https://www.morlaix-communaute.bzh/Se-deplacer/Velo/Prime-achat-Velo-a-Assistance-Electrique-VAE" },
  "aides . crozon":{ remplace:"intercommunalité",
    "applicable si":"localisation . epci = 'CC Presqu’île de Crozon-Aulne maritime'",
    variations:[ { si:"vélo . électrique",
        alors:"vélo . prix" },
      { si:{ "une de ces conditions":[ "vélo . cargo",
            "vélo . mécanique" ] },
        alors:"50% * vélo . prix" },
      { sinon:"0€" } ],
    plafond:"100€",
    lien:"https://www.comcom-crozon.com/amenagement-et-cadre-de-vie/transports-deplacements-randonnees/deplacements-doux/" },
  "aides . ploermel":{ remplace:"intercommunalité",
    "applicable si":"localisation . epci = 'CC Ploërmel Communauté'",
    variations:[ { si:"vélo . cargo électrique",
        alors:"400€" },
      { si:"vélo . cargo",
        alors:"200€" },
      { si:"vélo . électrique",
        alors:"100€" },
      { si:"vélo . mécanique",
        alors:"50€" },
      { sinon:"0€" } ],
    plafond:"vélo . prix",
    lien:"https://www.ploermelcommunaute.bzh/fonctionnalites/publications-131/l-aide-velo-ploermel-communaute-25650.html" },
  "aides . bar-le-duc":{ remplace:"commune",
    titre:"Ville de Bar-le-Duc",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '55029'",
        { "une de ces conditions":[ "vélo . électrique",
            "vélo . cargo",
            "vélo . pliant" ] } ] },
    valeur:"30% * vélo . prix",
    plafond:"300€",
    lien:"https://www.barleduc.fr/mon-quotidien/transports-et-stationnement/prolongement-de-loperation-dispositif-d-aide-a-l-acquisition-de-velo.html" },
  "aides . saint-jacques de la lande":{ remplace:"commune",
    titre:"Saint-Jacques de la Lande",
    "applicable si":"localisation . code insee = '35281'",
    valeur:{ variations:[ { si:"vélo . cargo",
          alors:"100€" },
        { si:"vélo . électrique",
          alors:"100€" },
        { si:"vélo . mécanique",
          alors:"75€" },
        { sinon:"0€" } ] },
    lien:"https://www.st-jacques.fr/infos-pratiques/acces-et-transport/subvention-velo/" },
  "aides . castres":{ remplace:"intercommunalité",
    titre:"Agglomération Castres-Mazamet",
    "applicable si":"localisation . epci = 'CA de Castres Mazamet'",
    valeur:"30% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"500€" },
        { si:"vélo . électrique",
          alors:"250€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"https://www.castres-mazamet.fr/plan-climat-air-energie-territorial/actualites" },
  "aides . lezennes":{ remplace:"commune",
    titre:"Ville de Lezennes",
    "applicable si":"localisation . code insee = '59346'",
    valeur:"50% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . cargo",
          alors:"450€" },
        { si:"vélo . électrique",
          alors:"300€" },
        { si:"vélo . mécanique",
          alors:"150€" } ] },
    lien:"https://droitauvelo.org/Ville-de-Lezennes-prime-a-l-achat-de-velos" },
  "aides . quesnoy-sur-deûle":{ remplace:"commune",
    titre:"Ville de Quesnoy-sur-Deûle",
    "applicable si":{ "toutes ces conditions":[ "localisation . code insee = '59482'",
        "vélo . électrique" ] },
    valeur:"20% * vélo . prix",
    plafond:"200€",
    lien:"http://www.quesnoysurdeule.fr/fr/actualite/202950" },
  "aides . arras":{ remplace:"intercommunalité",
    titre:"Communauté Urbaine d’Arras",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CU d’Arras'",
        "vélo . électrique" ] },
    valeur:"30% * vélo . prix",
    plafond:"300€",
    lien:"https://www.cu-arras.fr/a-votre-service/mobilite/" },
  "aides . pays de lumbres":{ remplace:"intercommunalité",
    titre:"Pays de Lumbres",
    "applicable si":"localisation . epci = 'CC du Pays de Lumbres'",
    valeur:"20% * vélo . prix",
    plafond:{ variations:[ { si:"vélo . électrique",
          alors:"250€" },
        { si:"vélo . mécanique",
          alors:"100€" },
        { sinon:"0€" } ] },
    lien:"http://www.cc-paysdelumbres.fr/Vie-pratique/Mobilites-durables/Aide-a-l-achat-pour-un-velo-avec-ou-sans-assistance" },
  "aides . boulonnais":{ remplace:"intercommunalité",
    titre:"Agglo Boulonnais",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA du Boulonnais'",
        "vélo . électrique" ] },
    valeur:"30% * vélo . prix",
    plafond:{ variations:[ { si:"ménage imposable",
          alors:"100€" },
        { sinon:"200€" } ] },
    lien:"https://www.agglo-boulonnais.fr/a-votre-service/mobilite/tous-a-velos" },
  "aides . chateauroux":{ remplace:"intercommunalité",
    titre:"Châteauroux Métropole",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CA Châteauroux Métropole'",
        "vélo . électrique" ] },
    valeur:"vélo . prix",
    plafond:"200€",
    lien:"https://www.chateauroux-metropole.fr/actualites-20/aide-a-lacquisition-dun-velo-a-assistance-electrique-vae-4838.html" },
  "aides . pontivy":{ remplace:"intercommunalité",
    titre:"Pontivy Communauté",
    "applicable si":{ "toutes ces conditions":[ "localisation . epci = 'CC Pontivy Communauté'",
        "vélo . électrique" ] },
    valeur:"vélo . prix",
    plafond:"200€",
    lien:"https://www.chateauroux-metropole.fr/actualites-20/aide-a-lacquisition-dun-velo-a-assistance-electrique-vae-4838.html" },
  "aides . monaco":{ remplace:"commune",
    titre:"Monaco",
    "applicable si":{ "toutes ces conditions":[ "vélo . électrique",
        "localisation . pays = 'Monaco'" ] },
    valeur:"30% * vélo . prix",
    plafond:"400€",
    lien:"https://www.gouv.mc/Action-Gouvernementale/L-Environnement/Une-mobilite-plus-douce/Dispositif-de-subventions-des-vehicules-electriques-et-hybrides" },
  "aides . luxembourg":{ remplace:"état",
    titre:"Luxembourg",
    description:"L’État du Luxembourg instaure une prime jusqu'à 600€ pour l’achat d’un vélo\nmécanique ou électrique (pedelec25) à des fins privées. Cette aide est\nplafonnée à 50% du prix du vélo hors taxes.\n",
    "applicable si":{ "toutes ces conditions":[ "vélo . électrique ou mécanique",
        "localisation . pays = 'Luxembourg'" ] },
    valeur:"50% * vélo . prix . HT",
    plafond:"600€",
    lien:"https://guichet.public.lu/fr/citoyens/transports-mobilite/transports-individuels/aides-financieres-acquisition-detention-vehicule/deduction-mobilite-durable-velo.html" },
  "vélo":"oui",
  "vélo . type":{ "possibilités":[ "mécanique simple",
      "électrique",
      "cargo",
      "cargo électrique",
      "pliant",
      "motorisation" ] },
  "vélo . mécanique simple":{ valeur:"oui",
    "applicable si":"vélo . type = 'mécanique simple'" },
  "vélo . électrique":{ valeur:"oui",
    "applicable si":{ "une de ces conditions":[ "vélo . type = 'électrique'",
        "vélo . type = 'cargo électrique'" ] } },
  "vélo . mécanique":{ valeur:"oui",
    "applicable si":{ "une de ces conditions":[ "vélo . type = 'mécanique simple'",
        "vélo . type = 'pliant'",
        "vélo . type = 'cargo'" ] } },
  "vélo . électrique ou mécanique":{ valeur:"oui",
    "applicable si":{ "une de ces conditions":[ "vélo . électrique",
        "vélo . mécanique" ] } },
  "vélo . cargo":{ valeur:"oui",
    "applicable si":{ "une de ces conditions":[ "vélo . type = 'cargo'",
        "vélo . type = 'cargo électrique'" ] } },
  "vélo . cargo électrique":{ valeur:"oui",
    "applicable si":"vélo . type = 'cargo électrique'" },
  "vélo . pliant":{ valeur:"oui",
    "applicable si":"vélo . type = 'pliant'" },
  "vélo . motorisation":{ valeur:"oui",
    "applicable si":"vélo . type = 'motorisation'",
    description:"Un kit de conversion permet de transformer un vélo mécanique classique en\nvélo à assistance électrique. Il est constitué d’un moteur électrique, d’une\nbatterie, ainsi que d’un contrôleur et d’un afficheur.\n" },
  "vélo . prix":{ question:{ variations:[ { si:"vélo . type = 'motorisation'",
          alors:"'Quel est le prix du kit de motorisation ?'" },
        { sinon:"'Quel est le prix du vélo ?'" } ] },
    "unité":"€",
    "par défaut":"prix pour maximiser les aides" },
  "vélo . taux TVA":{ variations:[ { si:"localisation . pays = 'Luxembourg'",
        alors:"17%" },
      { sinon:"20%" } ] },
  "vélo . prix . HT":{ valeur:"prix / (1 + taux TVA)" },
  "vélo . prix pour maximiser les aides":{ variations:[ { si:"vélo . type = ''",
        alors:"5000€" },
      { si:{ "une de ces conditions":[ "localisation . epci = 'CA du Grand Annecy'",
            "localisation . epci = 'CA Luberon Monts de Vaucluse'" ] },
        alors:"1000 €" },
      { si:"localisation . epci = 'CA La Roche sur Yon - Agglomération'",
        alors:"1500 €" },
      { si:{ "une de ces conditions":[ "localisation . epci = 'CA Montluçon Communauté'",
            "localisation . code insee = '14327'",
            "localisation . code insee = '14341'" ] },
        alors:"2400 €" },
      { si:"localisation . epci = 'Métropole de Lyon'",
        alors:"3000 €" },
      { si:"localisation . epci = 'CA Annemasse-Les Voirons-Agglomération'",
        alors:"4500 €" },
      { sinon:"5000 €" } ] },
  "vélo . fabriqué en france":{ question:"Le vélo est-il conçu et fabriqué en France ?",
    type:"booléen",
    "par défaut":"non" },
  "revenu fiscal de référence":{ question:"Quel est votre revenu annuel (quotient familial) ?",
    "par défaut":"800 €/an" },
  "ménage imposable":"revenu fiscal de référence >= 11120 €/an",
  "maximiser les aides":{ "par défaut":"non",
    remplace:[ { "règle":"vélo . prix",
        par:"vélo . prix pour maximiser les aides" },
      { "règle":"aides . pays de la loire . abonné TER",
        par:"oui" } ] },
  localisation:"oui",
  "localisation . code insee":"''",
  "localisation . epci":"''",
  "localisation . département":"''",
  "localisation . région":"''",
  "localisation . pays":{ variations:[ { si:"code insee = '99138'",
        alors:"'Monaco'" },
      { si:"code insee = '99137'",
        alors:"'Luxembourg'" },
      { sinon:"'France'" } ] } };
data.aides;
data.localisation;

var aidesAndCollectivities = {
	"aides . bonus vélo cargo": {
	collectivity: {
		kind: "pays",
		value: "France"
	},
	country: "france"
},
	"aides . bonus vélo électrique": {
	collectivity: {
		kind: "pays",
		value: "France"
	},
	country: "france"
},
	"aides . prime à la conversion": {
	collectivity: {
		kind: "pays",
		value: "France"
	},
	country: "france"
},
	"aides . ile de france": {
	collectivity: {
		kind: "région",
		value: "11"
	},
	codeInsee: "75056",
	slug: "paris",
	country: "france"
},
	"aides . occitanie": {
	collectivity: {
		kind: "région",
		value: "76"
	},
	codeInsee: "31555",
	slug: "toulouse",
	country: "france"
},
	"aides . corse": {
	collectivity: {
		kind: "région",
		value: "94"
	},
	codeInsee: "2A004",
	slug: "ajaccio",
	country: "france"
},
	"aides . grand est": {
	collectivity: {
		kind: "région",
		value: "44"
	},
	codeInsee: "67482",
	slug: "strasbourg",
	country: "france"
},
	"aides . bouches du rhone": {
	collectivity: {
		kind: "département",
		value: "13"
	},
	codeInsee: "13055",
	slug: "marseille",
	country: "france"
},
	"aides . paris": {
	collectivity: {
		kind: "code insee",
		value: "75056"
	},
	codeInsee: "75056",
	slug: "paris",
	country: "france"
},
	"aides . lyon": {
	collectivity: {
		kind: "epci",
		value: "Métropole de Lyon",
		code: "200046977"
	},
	codeInsee: "69123",
	slug: "lyon",
	country: "france"
},
	"aides . villefranche beaujolais saône": {
	collectivity: {
		kind: "epci",
		value: "CA Villefranche Beaujolais Saône",
		code: "200040590"
	},
	codeInsee: "69264",
	slug: "villefranche-sur-saone",
	country: "france"
},
	"aides . sainte foy lès lyon": {
	collectivity: {
		kind: "code insee",
		value: "69202"
	},
	codeInsee: "69202",
	slug: "sainte-foy-les-lyon",
	country: "france"
},
	"aides . mornant": {
	collectivity: {
		kind: "code insee",
		value: "69141"
	},
	codeInsee: "69141",
	slug: "mornant",
	country: "france"
},
	"aides . dardilly": {
	collectivity: {
		kind: "code insee",
		value: "69072"
	},
	codeInsee: "69072",
	slug: "dardilly",
	country: "france"
},
	"aides . saint-etienne": {
	collectivity: {
		kind: "epci",
		value: "Saint-Etienne Métropole",
		code: "244200770"
	},
	codeInsee: "42218",
	slug: "saint-etienne",
	country: "france"
},
	"aides . bordeaux": {
	collectivity: {
		kind: "epci",
		value: "Bordeaux Métropole",
		code: "243300316"
	},
	codeInsee: "33063",
	slug: "bordeaux",
	country: "france"
},
	"aides . département saône-et-loire": {
	collectivity: {
		kind: "département",
		value: "71"
	},
	codeInsee: "71270",
	slug: "macon",
	country: "france"
},
	"aides . mérignac": {
	collectivity: {
		kind: "code insee",
		value: "33281"
	},
	codeInsee: "33281",
	slug: "merignac-33",
	country: "france"
},
	"aides . saint-émilionnais": {
	collectivity: {
		kind: "epci",
		value: "CC du Grand Saint Emilionnais",
		code: "200035533"
	},
	codeInsee: "33485",
	slug: "sainte-terre",
	country: "france"
},
	"aides . pays de la loire": {
	collectivity: {
		kind: "région",
		value: "52"
	},
	codeInsee: "44109",
	slug: "nantes",
	country: "france"
},
	"aides . nantes": {
	collectivity: {
		kind: "epci",
		value: "Nantes Métropole",
		code: "244400404"
	},
	codeInsee: "44109",
	slug: "nantes",
	country: "france"
},
	"aides . toulouse": {
	collectivity: {
		kind: "epci",
		value: "Toulouse Métropole",
		code: "243100518"
	},
	codeInsee: "31555",
	slug: "toulouse",
	country: "france"
},
	"aides . nice": {
	collectivity: {
		kind: "epci",
		value: "Métropole Nice Côte d’Azur",
		code: "200030195"
	},
	codeInsee: "06088",
	slug: "nice",
	country: "france"
},
	"aides . strasbourg": {
	collectivity: {
		kind: "epci",
		value: "Eurométropole de Strasbourg",
		code: "246700488"
	},
	codeInsee: "67482",
	slug: "strasbourg",
	country: "france"
},
	"aides . entzheim": {
	collectivity: {
		kind: "code insee",
		value: "67124"
	},
	codeInsee: "67124",
	slug: "entzheim",
	country: "france"
},
	"aides . geispolsheim": {
	collectivity: {
		kind: "code insee",
		value: "67152"
	},
	codeInsee: "67152",
	slug: "geispolsheim",
	country: "france"
},
	"aides . hangenbieten": {
	collectivity: {
		kind: "code insee",
		value: "67182"
	},
	codeInsee: "67182",
	slug: "hangenbieten",
	country: "france"
},
	"aides . illkirch": {
	collectivity: {
		kind: "code insee",
		value: "67218"
	},
	codeInsee: "67218",
	slug: "illkirch-graffenstaden",
	country: "france"
},
	"aides . plobsheim": {
	collectivity: {
		kind: "code insee",
		value: "67378"
	},
	codeInsee: "67378",
	slug: "plobsheim",
	country: "france"
},
	"aides . vendenheim": {
	collectivity: {
		kind: "code insee",
		value: "67506"
	},
	codeInsee: "67506",
	slug: "vendenheim",
	country: "france"
},
	"aides . albi": {
	collectivity: {
		kind: "epci",
		value: "CA de l’Albigeois (C2A)",
		code: "248100737"
	},
	codeInsee: "81004",
	slug: "albi",
	country: "france"
},
	"aides . toulon": {
	collectivity: {
		kind: "epci",
		value: "Métropole Toulon-Provence-Méditerranée",
		code: "248300543"
	},
	codeInsee: "83137",
	slug: "toulon",
	country: "france"
},
	"aides . bretagne romantique": {
	collectivity: {
		kind: "epci",
		value: "CC Bretagne Romantique",
		code: "243500733"
	},
	codeInsee: "35085",
	slug: "combourg",
	country: "france"
},
	"aides . quimper": {
	collectivity: {
		kind: "epci",
		value: "CA Quimper Bretagne Occidentale",
		code: "200068120"
	},
	codeInsee: "29232",
	slug: "quimper",
	country: "france"
},
	"aides . quimperlé": {
	collectivity: {
		kind: "epci",
		value: "CA Quimperlé Communauté",
		code: "242900694"
	},
	codeInsee: "29233",
	slug: "quimperle",
	country: "france"
},
	"aides . laon": {
	collectivity: {
		kind: "epci",
		value: "CA du Pays de Laon",
		code: "200043495"
	},
	codeInsee: "02408",
	slug: "laon",
	country: "france"
},
	"aides . caen": {
	collectivity: {
		kind: "code insee",
		value: "14118"
	},
	codeInsee: "14118",
	slug: "caen",
	country: "france"
},
	"aides . caen la mer": {
	collectivity: {
		kind: "epci",
		value: "CU Caen la Mer",
		code: "200065597"
	},
	codeInsee: "14118",
	slug: "caen",
	country: "france"
},
	"aides . carpiquet": {
	collectivity: {
		kind: "code insee",
		value: "14137"
	},
	codeInsee: "14137",
	slug: "carpiquet",
	country: "france"
},
	"aides . herouville": {
	collectivity: {
		kind: "code insee",
		value: "14327"
	},
	codeInsee: "14327",
	slug: "herouville-saint-clair",
	country: "france"
},
	"aides . ifs": {
	collectivity: {
		kind: "code insee",
		value: "14341"
	},
	codeInsee: "14341",
	slug: "ifs",
	country: "france"
},
	"aides . mondeville": {
	collectivity: {
		kind: "code insee",
		value: "14437"
	},
	codeInsee: "14437",
	slug: "mondeville-14",
	country: "france"
},
	"aides . ronchin": {
	collectivity: {
		kind: "code insee",
		value: "59507"
	},
	codeInsee: "59507",
	slug: "ronchin",
	country: "france"
},
	"aides . porte du hainaut": {
	collectivity: {
		kind: "epci",
		value: "CA de la Porte du Hainaut",
		code: "200042190"
	},
	codeInsee: "59172",
	slug: "denain",
	country: "france"
},
	"aides . wasquehal": {
	collectivity: {
		kind: "code insee",
		value: "59646"
	},
	codeInsee: "59646",
	slug: "wasquehal",
	country: "france"
},
	"aides . ouistreham": {
	collectivity: {
		kind: "code insee",
		value: "14488"
	},
	codeInsee: "14488",
	slug: "ouistreham",
	country: "france"
},
	"aides . verson": {
	collectivity: {
		kind: "code insee",
		value: "14738"
	},
	codeInsee: "14738",
	slug: "verson",
	country: "france"
},
	"aides . cormelles le royal": {
	collectivity: {
		kind: "code insee",
		value: "14181"
	},
	codeInsee: "14181",
	slug: "cormelles-le-royal",
	country: "france"
},
	"aides . saint-germain la blanche herbe": {
	collectivity: {
		kind: "code insee",
		value: "14587"
	},
	codeInsee: "14587",
	slug: "saint-germain-la-blanche-herbe",
	country: "france"
},
	"aides . trouville sur mer": {
	collectivity: {
		kind: "code insee",
		value: "14715"
	},
	codeInsee: "14715",
	slug: "trouville-sur-mer",
	country: "france"
},
	"aides . deauville": {
	collectivity: {
		kind: "code insee",
		value: "14220"
	},
	codeInsee: "14220",
	slug: "deauville",
	country: "france"
},
	"aides . montlouis sur loire": {
	collectivity: {
		kind: "code insee",
		value: "37156"
	},
	codeInsee: "37156",
	slug: "montlouis-sur-loire",
	country: "france"
},
	"aides . martigues": {
	collectivity: {
		kind: "code insee",
		value: "13056"
	},
	codeInsee: "13056",
	slug: "martigues",
	country: "france"
},
	"aides . montbéliard agglo": {
	collectivity: {
		kind: "epci",
		value: "CA Pays de Montbéliard Agglomération",
		code: "200065647"
	},
	codeInsee: "25388",
	slug: "montbeliard",
	country: "france"
},
	"aides . besançon": {
	collectivity: {
		kind: "epci",
		value: "CU Grand Besançon Métropole",
		code: "242500361"
	},
	codeInsee: "25056",
	slug: "besancon",
	country: "france"
},
	"aides . montbéliard": {
	collectivity: {
		kind: "code insee",
		value: "25388"
	},
	codeInsee: "25388",
	slug: "montbeliard",
	country: "france"
},
	"aides . vienne condrieu": {
	collectivity: {
		kind: "epci",
		value: "CA Vienne Condrieu",
		code: "200077014"
	},
	codeInsee: "38544",
	slug: "vienne",
	country: "france"
},
	"aides . vif": {
	collectivity: {
		kind: "code insee",
		value: "38545"
	},
	codeInsee: "38545",
	slug: "vif",
	country: "france"
},
	"aides . meyreuil": {
	collectivity: {
		kind: "code insee",
		value: "13060"
	},
	codeInsee: "13060",
	slug: "meyreuil",
	country: "france"
},
	"aides . ploemeur": {
	collectivity: {
		kind: "code insee",
		value: "56162"
	},
	codeInsee: "56162",
	slug: "ploemeur",
	country: "france"
},
	"aides . daix": {
	collectivity: {
		kind: "code insee",
		value: "21223"
	},
	codeInsee: "21223",
	slug: "daix",
	country: "france"
},
	"aides . chateau du loir": {
	collectivity: {
		kind: "code insee",
		value: "33009"
	},
	codeInsee: "33009",
	slug: "arcachon",
	country: "france"
},
	"aides . sorgues du comtat": {
	collectivity: {
		kind: "epci",
		value: "CC des Sorgues du Comtat",
		code: "248400293"
	},
	codeInsee: "84129",
	slug: "sorgues",
	country: "france"
},
	"aides . grand périgueux": {
	collectivity: {
		kind: "epci",
		value: "CA Le Grand Périgueux",
		code: "200040392"
	},
	codeInsee: "24322",
	slug: "perigueux",
	country: "france"
},
	"aides . sarlat": {
	collectivity: {
		kind: "code insee",
		value: "24520"
	},
	codeInsee: "24520",
	slug: "sarlat-la-caneda",
	country: "france"
},
	"aides . sablé sur sarthe": {
	collectivity: {
		kind: "code insee",
		value: "72264"
	},
	codeInsee: "72264",
	slug: "sable-sur-sarthe",
	country: "france"
},
	"aides . département somme": {
	collectivity: {
		kind: "département",
		value: "80"
	},
	codeInsee: "80021",
	slug: "amiens",
	country: "france"
},
	"aides . amiens": {
	collectivity: {
		kind: "code insee",
		value: "80021"
	},
	codeInsee: "80021",
	slug: "amiens",
	country: "france"
},
	"aides . camon": {
	collectivity: {
		kind: "code insee",
		value: "80164"
	},
	codeInsee: "80164",
	slug: "camon-80",
	country: "france"
},
	"aides . rivery": {
	collectivity: {
		kind: "code insee",
		value: "80674"
	},
	codeInsee: "80674",
	slug: "rivery",
	country: "france"
},
	"aides . faches-thumesnil": {
	collectivity: {
		kind: "code insee",
		value: "59220"
	},
	codeInsee: "59220",
	slug: "faches-thumesnil",
	country: "france"
},
	"aides . pays sainte odile": {
	collectivity: {
		kind: "epci",
		value: "CC du Pays de Sainte-Odile",
		code: "246701080"
	},
	codeInsee: "67348",
	slug: "obernai",
	country: "france"
},
	"aides . portes de rosheim": {
	collectivity: {
		kind: "epci",
		value: "CC des Portes de Rosheim",
		code: "246700744"
	},
	codeInsee: "67411",
	slug: "rosheim",
	country: "france"
},
	"aides . pays rhénan": {
	collectivity: {
		kind: "epci",
		value: "CC du Pays Rhénan",
		code: "200041325"
	},
	codeInsee: "67106",
	slug: "drusenheim",
	country: "france"
},
	"aides . les sables d'olonne": {
	collectivity: {
		kind: "epci",
		value: "CA Les Sables d’Olonne Agglomération",
		code: "200071165"
	},
	codeInsee: "85194",
	slug: "les-sables-dolonne",
	country: "france"
},
	"aides . vallons du lyonnais": {
	collectivity: {
		kind: "epci",
		value: "CC des Vallons du Lyonnais (CCVL)",
		code: "246900724"
	},
	codeInsee: "69028",
	slug: "brindas",
	country: "france"
},
	"aides . département Hérault": {
	collectivity: {
		kind: "département",
		value: "34"
	},
	codeInsee: "34172",
	slug: "montpellier",
	country: "france"
},
	"aides . montpellier": {
	collectivity: {
		kind: "epci",
		value: "Montpellier Méditerranée Métropole",
		code: "243400017"
	},
	codeInsee: "34172",
	slug: "montpellier",
	country: "france"
},
	"aides . sete": {
	collectivity: {
		kind: "epci",
		value: "CA Sète Agglopôle Méditerranée",
		code: "200066355"
	},
	codeInsee: "34301",
	slug: "sete",
	country: "france"
},
	"aides . puy de dome": {
	collectivity: {
		kind: "département",
		value: "63"
	},
	codeInsee: "63113",
	slug: "clermont-ferrand",
	country: "france"
},
	"aides . pays d'issoire": {
	collectivity: {
		kind: "epci",
		value: "CA Agglo Pays d’Issoire",
		code: "200070407"
	},
	codeInsee: "63178",
	slug: "issoire",
	country: "france"
},
	"aides . cébazat": {
	collectivity: {
		kind: "code insee",
		value: "63063"
	},
	codeInsee: "63063",
	slug: "cebazat",
	country: "france"
},
	"aides . aubiere": {
	collectivity: {
		kind: "code insee",
		value: "63014"
	},
	codeInsee: "63014",
	slug: "aubiere",
	country: "france"
},
	"aides . romagnat": {
	collectivity: {
		kind: "code insee",
		value: "63307"
	},
	codeInsee: "63307",
	slug: "romagnat",
	country: "france"
},
	"aides . cournon d'auvergne": {
	collectivity: {
		kind: "code insee",
		value: "63124"
	},
	codeInsee: "63124",
	slug: "cournon-dauvergne",
	country: "france"
},
	"aides . colmar": {
	collectivity: {
		kind: "code insee",
		value: "68066"
	},
	codeInsee: "68066",
	slug: "colmar",
	country: "france"
},
	"aides . avignon": {
	collectivity: {
		kind: "epci",
		value: "CA du Grand Avignon (COGA)",
		code: "248400251"
	},
	codeInsee: "84007",
	slug: "avignon",
	country: "france"
},
	"aides . luberon": {
	collectivity: {
		kind: "epci",
		value: "CA Luberon Monts de Vaucluse",
		code: "200040442"
	},
	codeInsee: "84035",
	slug: "cavaillon",
	country: "france"
},
	"aides . charenton": {
	collectivity: {
		kind: "code insee",
		value: "94018"
	},
	codeInsee: "94018",
	slug: "charenton-le-pont",
	country: "france"
},
	"aides . pau": {
	collectivity: {
		kind: "epci",
		value: "CA Pau Béarn Pyrénées",
		code: "200067254"
	},
	codeInsee: "64445",
	slug: "pau",
	country: "france"
},
	"aides . pays basque": {
	collectivity: {
		kind: "epci",
		value: "CA du Pays Basque",
		code: "200067106"
	},
	codeInsee: "64102",
	slug: "bayonne",
	country: "france"
},
	"aides . grand lac": {
	collectivity: {
		kind: "epci",
		value: "CA Grand Lac",
		code: "200068674"
	},
	codeInsee: "73008",
	slug: "aix-les-bains",
	country: "france"
},
	"aides . aix les bains": {
	collectivity: {
		kind: "code insee",
		value: "73008"
	},
	codeInsee: "73008",
	slug: "aix-les-bains",
	country: "france"
},
	"aides . bourget-du-lac": {
	collectivity: {
		kind: "code insee",
		value: "73051"
	},
	codeInsee: "73051",
	slug: "le-bourget-du-lac",
	country: "france"
},
	"aides . la motte servolex": {
	collectivity: {
		kind: "code insee",
		value: "73179"
	},
	codeInsee: "73179",
	slug: "la-motte-servolex",
	country: "france"
},
	"aides . ardenne": {
	collectivity: {
		kind: "epci",
		value: "CA Ardenne Métropole",
		code: "200041630"
	},
	codeInsee: "08105",
	slug: "charleville-mezieres",
	country: "france"
},
	"aides . erdregesvres": {
	collectivity: {
		kind: "epci",
		value: "CC d’Erdre et Gesvres",
		code: "244400503"
	},
	codeInsee: "44209",
	slug: "treillieres",
	country: "france"
},
	"aides . cote d'or": {
	collectivity: {
		kind: "département",
		value: "21"
	},
	codeInsee: "21231",
	slug: "dijon",
	country: "france"
},
	"aides . lot": {
	collectivity: {
		kind: "département",
		value: "46"
	},
	codeInsee: "46042",
	slug: "cahors",
	country: "france"
},
	"aides . sophia antipolis": {
	collectivity: {
		kind: "epci",
		value: "CA de Sophia Antipolis",
		code: "240600585"
	},
	codeInsee: "06004",
	slug: "antibes",
	country: "france"
},
	"aides . mougins": {
	collectivity: {
		kind: "code insee",
		value: "06085"
	},
	codeInsee: "06085",
	slug: "mougins",
	country: "france"
},
	"aides . mandelieu": {
	collectivity: {
		kind: "code insee",
		value: "06079"
	},
	codeInsee: "06079",
	slug: "mandelieu-la-napoule",
	country: "france"
},
	"aides . pantin": {
	collectivity: {
		kind: "code insee",
		value: "93055"
	},
	codeInsee: "93055",
	slug: "pantin",
	country: "france"
},
	"aides . vaucresson": {
	collectivity: {
		kind: "code insee",
		value: "92076"
	},
	codeInsee: "92076",
	slug: "vaucresson",
	country: "france"
},
	"aides . courbevoie": {
	collectivity: {
		kind: "code insee",
		value: "92026"
	},
	codeInsee: "92026",
	slug: "courbevoie",
	country: "france"
},
	"aides . mons en baroeul": {
	collectivity: {
		kind: "code insee",
		value: "59410"
	},
	codeInsee: "59410",
	slug: "mons-en-barul",
	country: "france"
},
	"aides . la madeleine": {
	collectivity: {
		kind: "code insee",
		value: "59368"
	},
	codeInsee: "59368",
	slug: "la-madeleine",
	country: "france"
},
	"aides . nevers": {
	collectivity: {
		kind: "epci",
		value: "CA de Nevers",
		code: "245804406"
	},
	codeInsee: "58194",
	slug: "nevers",
	country: "france"
},
	"aides . aurillac": {
	collectivity: {
		kind: "epci",
		value: "CA du Bassin d’Aurillac",
		code: "241500230"
	},
	codeInsee: "15014",
	slug: "aurillac",
	country: "france"
},
	"aides . terre des 2 caps": {
	collectivity: {
		kind: "epci",
		value: "CC de la Terre des Deux Caps",
		code: "246200380"
	},
	codeInsee: "62560",
	slug: "marquise",
	country: "france"
},
	"aides . carvin": {
	collectivity: {
		kind: "code insee",
		value: "62215"
	},
	codeInsee: "62215",
	slug: "carvin",
	country: "france"
},
	"aides . les herbiers": {
	collectivity: {
		kind: "epci",
		value: "CC du Pays des Herbiers",
		code: "248500621"
	},
	codeInsee: "85109",
	slug: "les-herbiers",
	country: "france"
},
	"aides . riviera francaise": {
	collectivity: {
		kind: "epci",
		value: "CA de la Riviera Française",
		code: "240600551"
	},
	codeInsee: "06083",
	slug: "menton",
	country: "france"
},
	"aides . frejus": {
	collectivity: {
		kind: "code insee",
		value: "83061"
	},
	codeInsee: "83061",
	slug: "frejus",
	country: "france"
},
	"aides . orléans": {
	collectivity: {
		kind: "epci",
		value: "Orléans Métropole",
		code: "244500468"
	},
	codeInsee: "45234",
	slug: "orleans",
	country: "france"
},
	"aides . chalette-sur-loing": {
	collectivity: {
		kind: "code insee",
		value: "45068"
	},
	codeInsee: "45068",
	slug: "chalette-sur-loing",
	country: "france"
},
	"aides . reims": {
	collectivity: {
		kind: "code insee",
		value: "51454"
	},
	codeInsee: "51454",
	slug: "reims",
	country: "france"
},
	"aides . grand reims": {
	collectivity: {
		kind: "epci",
		value: "CU du Grand Reims",
		code: "200067213"
	},
	codeInsee: "51454",
	slug: "reims",
	country: "france"
},
	"aides . annecy": {
	collectivity: {
		kind: "epci",
		value: "CA du Grand Annecy",
		code: "200066793"
	},
	codeInsee: "74010",
	slug: "annecy-74",
	country: "france"
},
	"aides . genevois": {
	collectivity: {
		kind: "epci",
		value: "CC du Genevois",
		code: "247400690"
	},
	codeInsee: "74243",
	slug: "saint-julien-en-genevois",
	country: "france"
},
	"aides . évian-les-bains": {
	collectivity: {
		kind: "code insee",
		value: "74119"
	},
	codeInsee: "74119",
	slug: "evian-les-bains",
	country: "france"
},
	"aides . marignier": {
	collectivity: {
		kind: "code insee",
		value: "74164"
	},
	codeInsee: "74164",
	slug: "marignier",
	country: "france"
},
	"aides . combloux": {
	collectivity: {
		kind: "code insee",
		value: "74083"
	},
	codeInsee: "74083",
	slug: "combloux",
	country: "france"
},
	"aides . angers": {
	collectivity: {
		kind: "epci",
		value: "CU Angers Loire Métropole",
		code: "244900015"
	},
	codeInsee: "49007",
	slug: "angers",
	country: "france"
},
	"aides . brissac loire aubance": {
	collectivity: {
		kind: "epci",
		value: "CC Loire Layon Aubance",
		code: "200071553"
	},
	codeInsee: "49050",
	slug: "brissac-loire-aubance",
	country: "france"
},
	"aides . châtellrault": {
	collectivity: {
		kind: "epci",
		value: "CA Grand Châtellerault",
		code: "248600413"
	},
	codeInsee: "86066",
	slug: "chatellerault",
	country: "france"
},
	"aides . pays de l'or": {
	collectivity: {
		kind: "epci",
		value: "CA du Pays de l’Or",
		code: "243400470"
	},
	codeInsee: "34154",
	slug: "mauguio",
	country: "france"
},
	"aides . annemasse": {
	collectivity: {
		kind: "epci",
		value: "CA Annemasse-Les Voirons-Agglomération",
		code: "200011773"
	},
	codeInsee: "74012",
	slug: "annemasse",
	country: "france"
},
	"aides . montlucon": {
	collectivity: {
		kind: "epci",
		value: "CA Montluçon Communauté",
		code: "200071082"
	},
	codeInsee: "03185",
	slug: "montlucon",
	country: "france"
},
	"aides . cotentin": {
	collectivity: {
		kind: "epci",
		value: "CA du Cotentin",
		code: "200067205"
	},
	codeInsee: "50129",
	slug: "cherbourg-en-cotentin",
	country: "france"
},
	"aides . granville": {
	collectivity: {
		kind: "code insee",
		value: "50218"
	},
	codeInsee: "50218",
	slug: "granville",
	country: "france"
},
	"aides . la rochelle": {
	collectivity: {
		kind: "epci",
		value: "CA de La Rochelle",
		code: "241700434"
	},
	codeInsee: "17300",
	slug: "la-rochelle-17",
	country: "france"
},
	"aides . blois": {
	collectivity: {
		kind: "epci",
		value: "CA de Blois ’’Agglopolys’’",
		code: "200030385"
	},
	codeInsee: "41018",
	slug: "blois",
	country: "france"
},
	"aides . epinal": {
	collectivity: {
		kind: "epci",
		value: "CA d’Epinal",
		code: "200068757"
	},
	codeInsee: "88160",
	slug: "epinal",
	country: "france"
},
	"aides . vannes": {
	collectivity: {
		kind: "epci",
		value: "CA Golfe du Morbihan - Vannes Agglomération",
		code: "200067932"
	},
	codeInsee: "56260",
	slug: "vannes",
	country: "france"
},
	"aides . quéven": {
	collectivity: {
		kind: "code insee",
		value: "56185"
	},
	codeInsee: "56185",
	slug: "queven",
	country: "france"
},
	"aides . rochefort": {
	collectivity: {
		kind: "epci",
		value: "CA Rochefort Océan",
		code: "200041762"
	},
	codeInsee: "17299",
	slug: "rochefort-17",
	country: "france"
},
	"aides . saintes": {
	collectivity: {
		kind: "epci",
		value: "CA de Saintes",
		code: "200036473"
	},
	codeInsee: "17415",
	slug: "saintes",
	country: "france"
},
	"aides . yvetot normandie": {
	collectivity: {
		kind: "epci",
		value: "CC Yvetot Normandie",
		code: "247600620"
	},
	codeInsee: "76758",
	slug: "yvetot",
	country: "france"
},
	"aides . arcachon": {
	collectivity: {
		kind: "code insee",
		value: "33009"
	},
	codeInsee: "33009",
	slug: "arcachon",
	country: "france"
},
	"aides . bourges": {
	collectivity: {
		kind: "epci",
		value: "CA Bourges Plus",
		code: "241800507"
	},
	codeInsee: "18033",
	slug: "bourges",
	country: "france"
},
	"aides . tulle": {
	collectivity: {
		kind: "epci",
		value: "CA Tulle Agglo",
		code: "241927201"
	},
	codeInsee: "19272",
	slug: "tulle",
	country: "france"
},
	"aides . corrèze": {
	collectivity: {
		kind: "code insee",
		value: "19062"
	},
	codeInsee: "19062",
	slug: "correze",
	country: "france"
},
	"aides . montauban": {
	collectivity: {
		kind: "epci",
		value: "CA Grand Montauban",
		code: "248200099"
	},
	codeInsee: "82121",
	slug: "montauban",
	country: "france"
},
	"aides . mont de marsan": {
	collectivity: {
		kind: "epci",
		value: "CA Mont de Marsan Agglomération",
		code: "244000808"
	},
	codeInsee: "40192",
	slug: "mont-de-marsan",
	country: "france"
},
	"aides . bourg en bresse": {
	collectivity: {
		kind: "code insee",
		value: "01053"
	},
	codeInsee: "01053",
	slug: "bourg-en-bresse",
	country: "france"
},
	"aides . divonne-les-bains": {
	collectivity: {
		kind: "code insee",
		value: "01143"
	},
	codeInsee: "01143",
	slug: "divonne-les-bains",
	country: "france"
},
	"aides . valence romans": {
	collectivity: {
		kind: "epci",
		value: "CA Valence Romans Agglo",
		code: "200068781"
	},
	codeInsee: "26362",
	slug: "valence-26",
	country: "france"
},
	"aides . dieulefit-bourdeaux": {
	collectivity: {
		kind: "epci",
		value: "CC Dieulefit-Bourdeaux",
		code: "242600492"
	},
	codeInsee: "26114",
	slug: "dieulefit",
	country: "france"
},
	"aides . lorient": {
	collectivity: {
		kind: "epci",
		value: "CA Lorient Agglomération",
		code: "200042174"
	},
	codeInsee: "56121",
	slug: "lorient",
	country: "france"
},
	"aides . la roche sur yon": {
	collectivity: {
		kind: "epci",
		value: "CA La Roche sur Yon - Agglomération",
		code: "248500589"
	},
	codeInsee: "85191",
	slug: "la-roche-sur-yon",
	country: "france"
},
	"aides . cholet": {
	collectivity: {
		kind: "epci",
		value: "CA Agglomération du Choletais",
		code: "200071678"
	},
	codeInsee: "49099",
	slug: "cholet",
	country: "france"
},
	"aides . laval": {
	collectivity: {
		kind: "epci",
		value: "CA Laval Agglomération",
		code: "200083392"
	},
	codeInsee: "53130",
	slug: "laval",
	country: "france"
},
	"aides . ernée": {
	collectivity: {
		kind: "epci",
		value: "CC de l’Ernée",
		code: "245300355"
	},
	codeInsee: "53096",
	slug: "ernee",
	country: "france"
},
	"aides . saint-martin-de-crau": {
	collectivity: {
		kind: "code insee",
		value: "13097"
	},
	codeInsee: "13097",
	slug: "saint-martin-de-crau",
	country: "france"
},
	"aides . brive": {
	collectivity: {
		kind: "epci",
		value: "CA du Bassin de Brive",
		code: "200043172"
	},
	codeInsee: "19031",
	slug: "brive-la-gaillarde",
	country: "france"
},
	"aides . pays de saint gilles": {
	collectivity: {
		kind: "epci",
		value: "CC du Pays de Saint-Gilles-Croix-de-Vie",
		code: "200023778"
	},
	codeInsee: "85226",
	slug: "saint-hilaire-de-riez",
	country: "france"
},
	"aides . ville de talant": {
	collectivity: {
		kind: "code insee",
		value: "21617"
	},
	codeInsee: "21617",
	slug: "talant",
	country: "france"
},
	"aides . vendée grand littoral": {
	collectivity: {
		kind: "epci",
		value: "CC Vendée Grand Littoral",
		code: "200071900"
	},
	codeInsee: "85288",
	slug: "talmont-saint-hilaire",
	country: "france"
},
	"aides . pays des achards": {
	collectivity: {
		kind: "epci",
		value: "CC du Pays des Achards",
		code: "248500530"
	},
	codeInsee: "85152",
	slug: "les-achards",
	country: "france"
},
	"aides . hem": {
	collectivity: {
		kind: "code insee",
		value: "59299"
	},
	codeInsee: "59299",
	slug: "hem",
	country: "france"
},
	"aides . saint-omer": {
	collectivity: {
		kind: "epci",
		value: "CA du Pays de Saint-Omer",
		code: "200069037"
	},
	codeInsee: "62765",
	slug: "saint-omer-62",
	country: "france"
},
	"aides . comines": {
	collectivity: {
		kind: "code insee",
		value: "59152"
	},
	codeInsee: "59152",
	slug: "comines",
	country: "france"
},
	"aides . liévin": {
	collectivity: {
		kind: "code insee",
		value: "62510"
	},
	codeInsee: "62510",
	slug: "lievin",
	country: "france"
},
	"aides . béthune": {
	collectivity: {
		kind: "code insee",
		value: "62119"
	},
	codeInsee: "62119",
	slug: "bethune",
	country: "france"
},
	"aides . baisieux": {
	collectivity: {
		kind: "code insee",
		value: "59044"
	},
	codeInsee: "59044",
	slug: "baisieux",
	country: "france"
},
	"aides . billy-berclau": {
	collectivity: {
		kind: "code insee",
		value: "62132"
	},
	codeInsee: "62132",
	slug: "billy-berclau",
	country: "france"
},
	"aides . marquette-lez-lille": {
	collectivity: {
		kind: "code insee",
		value: "59386"
	},
	codeInsee: "59386",
	slug: "marquette-lez-lille",
	country: "france"
},
	"aides . gruson": {
	collectivity: {
		kind: "code insee",
		value: "59275"
	},
	codeInsee: "59275",
	slug: "gruson",
	country: "france"
},
	"aides . dunkerque": {
	collectivity: {
		kind: "epci",
		value: "CU de Dunkerque",
		code: "245900428"
	},
	codeInsee: "59183",
	slug: "dunkerque",
	country: "france"
},
	"aides . flandre intérieure": {
	collectivity: {
		kind: "epci",
		value: "CC de Flandre Intérieure",
		code: "200040947"
	},
	codeInsee: "59295",
	slug: "hazebrouck",
	country: "france"
},
	"aides . grande-synthe": {
	collectivity: {
		kind: "code insee",
		value: "59271"
	},
	codeInsee: "59271",
	slug: "grande-synthe",
	country: "france"
},
	"aides . valenciennes": {
	collectivity: {
		kind: "epci",
		value: "CA Valenciennes Métropole",
		code: "245901160"
	},
	codeInsee: "59606",
	slug: "valenciennes",
	country: "france"
},
	"aides . thiais": {
	collectivity: {
		kind: "code insee",
		value: "94073"
	},
	codeInsee: "94073",
	slug: "thiais",
	country: "france"
},
	"aides . nanterre": {
	collectivity: {
		kind: "code insee",
		value: "92050"
	},
	codeInsee: "92050",
	slug: "nanterre",
	country: "france"
},
	"aides . genneviliers": {
	collectivity: {
		kind: "code insee",
		value: "92036"
	},
	codeInsee: "92036",
	slug: "gennevilliers",
	country: "france"
},
	"aides . drancy": {
	collectivity: {
		kind: "code insee",
		value: "93029"
	},
	codeInsee: "93029",
	slug: "drancy",
	country: "france"
},
	"aides . fontenay": {
	collectivity: {
		kind: "code insee",
		value: "94033"
	},
	codeInsee: "94033",
	slug: "fontenay-sous-bois",
	country: "france"
},
	"aides . rives de moselle": {
	collectivity: {
		kind: "epci",
		value: "CC Rives de Moselle",
		code: "200039949"
	},
	codeInsee: "57433",
	slug: "maizieres-les-metz",
	country: "france"
},
	"aides . thionville": {
	collectivity: {
		kind: "code insee",
		value: "57672"
	},
	codeInsee: "57672",
	slug: "thionville",
	country: "france"
},
	"aides . betheny": {
	collectivity: {
		kind: "code insee",
		value: "51055"
	},
	codeInsee: "51055",
	slug: "betheny",
	country: "france"
},
	"aides . épernay": {
	collectivity: {
		kind: "code insee",
		value: "51230"
	},
	codeInsee: "51230",
	slug: "epernay",
	country: "france"
},
	"aides . brest": {
	collectivity: {
		kind: "epci",
		value: "Brest Métropole",
		code: "242900314"
	},
	codeInsee: "29019",
	slug: "brest",
	country: "france"
},
	"aides . plouzané": {
	collectivity: {
		kind: "code insee",
		value: "29212"
	},
	codeInsee: "29212",
	slug: "plouzane",
	country: "france"
},
	"aides . gouesnou": {
	collectivity: {
		kind: "code insee",
		value: "29061"
	},
	codeInsee: "29061",
	slug: "gouesnou",
	country: "france"
},
	"aides . pougastel-daoulas": {
	collectivity: {
		kind: "code insee",
		value: "29189"
	},
	codeInsee: "29189",
	slug: "plougastel-daoulas",
	country: "france"
},
	"aides . saint-pol-de-léon": {
	collectivity: {
		kind: "code insee",
		value: "29259"
	},
	codeInsee: "29259",
	slug: "saint-pol-de-leon",
	country: "france"
},
	"aides . saint-malo": {
	collectivity: {
		kind: "epci",
		value: "CA du Pays de Saint Malo Agglomération",
		code: "243500782"
	},
	codeInsee: "35288",
	slug: "saint-malo",
	country: "france"
},
	"aides . saint-brieuc armor": {
	collectivity: {
		kind: "epci",
		value: "CA Saint-Brieuc Armor Agglomération",
		code: "200069409"
	},
	codeInsee: "22278",
	slug: "saint-brieuc",
	country: "france"
},
	"aides . lannion-trégor": {
	collectivity: {
		kind: "epci",
		value: "CA Lannion-Trégor Communauté",
		code: "200065928"
	},
	codeInsee: "22113",
	slug: "lannion",
	country: "france"
},
	"aides . perros-guirec": {
	collectivity: {
		kind: "code insee",
		value: "22168"
	},
	codeInsee: "22168",
	slug: "perros-guirec",
	country: "france"
},
	"aides . bar-le-duc": {
	collectivity: {
		kind: "code insee",
		value: "55029"
	},
	codeInsee: "55029",
	slug: "bar-le-duc",
	country: "france"
},
	"aides . saint-jacques de la lande": {
	collectivity: {
		kind: "code insee",
		value: "35281"
	},
	codeInsee: "35281",
	slug: "saint-jacques-de-la-lande",
	country: "france"
},
	"aides . castres": {
	collectivity: {
		kind: "epci",
		value: "CA de Castres Mazamet",
		code: "248100430"
	},
	codeInsee: "81065",
	slug: "castres-81",
	country: "france"
},
	"aides . lezennes": {
	collectivity: {
		kind: "code insee",
		value: "59346"
	},
	codeInsee: "59346",
	slug: "lezennes",
	country: "france"
},
	"aides . quesnoy-sur-deûle": {
	collectivity: {
		kind: "code insee",
		value: "59482"
	},
	codeInsee: "59482",
	slug: "quesnoy-sur-deule",
	country: "france"
},
	"aides . arras": {
	collectivity: {
		kind: "epci",
		value: "CU d’Arras",
		code: "200033579"
	},
	codeInsee: "62041",
	slug: "arras",
	country: "france"
},
	"aides . pays de lumbres": {
	collectivity: {
		kind: "epci",
		value: "CC du Pays de Lumbres",
		code: "246201016"
	},
	codeInsee: "62534",
	slug: "lumbres",
	country: "france"
},
	"aides . boulonnais": {
	collectivity: {
		kind: "epci",
		value: "CA du Boulonnais",
		code: "246200729"
	},
	codeInsee: "62160",
	slug: "boulogne-sur-mer",
	country: "france"
},
	"aides . chateauroux": {
	collectivity: {
		kind: "epci",
		value: "CA Châteauroux Métropole",
		code: "243600327"
	},
	codeInsee: "36044",
	slug: "chateauroux",
	country: "france"
},
	"aides . pontivy": {
	collectivity: {
		kind: "epci",
		value: "CC Pontivy Communauté",
		code: "245614433"
	},
	codeInsee: "56178",
	slug: "pontivy",
	country: "france"
},
	"aides . monaco": {
	collectivity: {
		kind: "pays",
		value: "Monaco"
	},
	country: "monaco"
},
	"aides . luxembourg": {
	collectivity: {
		kind: "pays",
		value: "Luxembourg"
	},
	country: "luxembourg"
}
};

// TODO: To we really need this feature? Could we automatically infer descriptions from the formulas?
const defaultDescription = '';
function formatDescription({ ruleName, engine, veloCat }) {
	const { rawNode } = engine.getRule(ruleName);
	const description = rawNode?.description ?? defaultDescription;
	const plafondRuleName = `${ruleName} . $plafond`;
	const plafondIsDefined = Object.keys(engine.parsedRules).includes(plafondRuleName);
	const plafond = plafondIsDefined && engine.evaluate(plafondRuleName);
	return description
		.replace(/\$vélo/g, veloCat === 'motorisation' ? 'kit de motorisation' : `vélo ${veloCat}`)
		.replace(/\$plafond/, Publicodes.formatValue(plafond?.nodeValue, { displayedUnit: '€' }));
}

const engine = new Publicodes__default["default"](data);
/**
 *  Retourne la liste des aides disponibles pour une situation donnée
 */
function aidesVelo(situation = {}) {
    engine.setSituation(formatInput(situation));
    return Object.entries(aidesAndCollectivities)
        .filter(([, { country: aideCountry }]) => !situation['localisation . pays'] || aideCountry === situation['localisation . pays'])
        .flatMap(([ruleName]) => {
        const rule = engine.getRule(ruleName);
        const collectivity = aidesAndCollectivities[ruleName].collectivity;
        const metaData = {
            id: ruleName,
            title: rule.title,
            description: rule.rawNode.description,
            url: rule.rawNode.lien,
            collectivity
        };
        if (!situation['vélo . type']) {
            return [metaData];
        }
        const { nodeValue } = engine.evaluate({ valeur: ruleName, unité: '€' });
        if (typeof nodeValue === 'number' && nodeValue > 0) {
            return [
                Object.assign(Object.assign({}, metaData), { description: formatDescription({
                        ruleName,
                        engine,
                        veloCat: situation['vélo . type']
                    }), amount: nodeValue })
            ];
        }
        else {
            return [];
        }
    });
}
const formatInput = (input) => Object.fromEntries(Object.entries(input).map(([key, val]) => {
    var _a;
    return [
        key,
        key === 'localisation . epci'
            ? `'${(_a = epciSirenToName[val]) === null || _a === void 0 ? void 0 : _a.replace(/'/g, '’')}'`
            : typeof val === 'string'
                ? `'${val.replace(/'/g, '’')}'`
                : val
    ];
}));
const epciSirenToName = Object.fromEntries(Object.values(aidesAndCollectivities).flatMap(({ collectivity }) => {
    if (collectivity.kind !== 'epci') {
        return [];
    }
    return [[collectivity.code, collectivity.value]];
}));

module.exports = aidesVelo;
